let quickActionsDockPositionRaf = 0;
let quickActionsDockTrackRaf = 0;
let quickActionsDockTrackUntil = 0;
let quizCardHeightNormalizeRaf = 0;
let quizCardHeightObserver = null;
let quizWorkspaceWidthObserver = null;
let quizWorkspaceWidthSettleTimer = 0;
let isQuizCardManualResizeActive = false;
let activePopupPositionSyncRaf = 0;
const QUICK_ACTIONS_DOCK_LAYOUT_TRACK_MS = 520;
let quizCardContentScalePendingForceReset = false;
let quizCardLayoutSettlePassRunning = false;
let quizCompanionFollowFrame = 0;
let quizCompanionFollowRunning = false;

// Pane open/close animates grid tracks for ~620ms. Every frame of that
// animation resizes the quiz card and both panes, so the observers and rAF
// trackers below would otherwise re-measure and re-write layout on every one
// of those frames. They defer to a single pass once the layout lands instead.
// The settle callbacks are module-level named functions so the settle Set
// dedupes repeat registrations to one entry.
function isQuizPaneLayoutTransitioning() {
    // The settle pass is the work these gates were deferring, so it must never
    // be gated by them - otherwise a transition that overlaps the settle would
    // re-defer it and the dock could stay parked. The companion follower below
    // is the one per-frame pass a transition allows.
    if (quizCardLayoutSettlePassRunning || quizCompanionFollowRunning) return false;
    return !!window.isPaneLayoutTransitioning?.();
}

// Returns true when the side pane's vertical box changed. The variables are inherited by the whole
// work area, so unchanged values are not rewritten.
function syncQuizCompanionVerticalGeometry() {
    const card = els?.quizCard || $('quiz-card');
    const workArea = els?.workArea || $('work-area');
    if (!card || !workArea || getComputedStyle(card).display === 'none') return false;
    const cardRect = card.getBoundingClientRect();
    if (!(cardRect.height > 0)) return false;

    let changed = false;
    if (workArea.classList.contains('split-view') || workArea.classList.contains('pdf-tutor-quiz-duo')) {
        const areaRect = workArea.getBoundingClientRect();
        const top = `${Math.max(8, Math.round(cardRect.top - areaRect.top))}px`;
        const height = `${Math.max(0, Math.min(Math.round(cardRect.height), Math.round(areaRect.height - parseFloat(top) - 8)))}px`;
        if (workArea.style.getPropertyValue('--quiz-source-panel-top') !== top) {
            workArea.style.setProperty('--quiz-source-panel-top', top);
            changed = true;
        }
        if (workArea.style.getPropertyValue('--quiz-source-panel-height') !== height) {
            workArea.style.setProperty('--quiz-source-panel-height', height);
            changed = true;
        }
    }
    if (quizCompanionFollowRunning) return changed;
    if ($('notes-modal')?.dataset.layoutMode === 'docked' && typeof syncNotesSurfaceLayout === 'function') {
        syncNotesSurfaceLayout();
    } else if ($('ask-ai-modal')?.dataset.layoutMode === 'docked' && typeof syncAskAIModalPosition === 'function') {
        syncAskAIModalPosition();
    }
    return changed;
}

/* While a pane opens or closes, the Tools dock and the side pane's vertical box follow the card
   frame by frame. rAF runs after the frame's animation values apply, so these reads land in the
   layout that frame needs anyway. The dock used to park (hidden) for the whole transition, and
   the side pane, with Ask or Notes over it, only matched the card's height once it settled. */
function followQuizCompanionsForPaneFrame() {
    quizCompanionFollowRunning = true;
    try {
        positionQuickActionsDock();
        if (syncQuizCompanionVerticalGeometry() && document.body.classList.contains('quiz-side-surface-in-pane')) {
            if ($('ask-ai-modal')?.classList.contains('active') && typeof syncAskAIModalPosition === 'function') {
                syncAskAIModalPosition();
            } else if ($('notes-modal')?.classList.contains('active') && typeof syncNotesSurfaceLayout === 'function') {
                syncNotesSurfaceLayout();
            }
        }
    } finally {
        quizCompanionFollowRunning = false;
    }
}
window.followQuizCompanionsForPaneFrame = followQuizCompanionsForPaneFrame;

function followQuizCompanionsThroughPaneTransition() {
    // A concealed source has nothing to follow. The dock is mounted on the card and moves in CSS;
    // writing inherited source-panel geometry every frame woke the whole workspace's observers.
    if (typeof isQuizSlidePaneSourceDeferred === 'function' && isQuizSlidePaneSourceDeferred()) {
        window.whenPaneLayoutSettled?.(runQuizCardLayoutSettlePass);
        return;
    }
    if (quizCompanionFollowFrame) return;
    const step = () => {
        quizCompanionFollowFrame = 0;
        // The settle pass places everything exactly once the transition ends.
        if (!window.isPaneLayoutTransitioning?.()) return;
        // A frame-driven expansion calls followQuizCompanionsForPaneFrame itself, after it writes
        // the tracks; reading here first would lay the workspace out twice per frame.
        if (!(els?.workArea || $('work-area'))?.classList.contains('pane-open-expanding')) {
            followQuizCompanionsForPaneFrame();
        }
        quizCompanionFollowFrame = requestAnimationFrame(step);
    };
    quizCompanionFollowFrame = requestAnimationFrame(step);
}
window.followQuizCompanionsThroughPaneTransition = followQuizCompanionsThroughPaneTransition;

function runQuizCardLayoutSettlePass() {
    const forceReset = quizCardContentScalePendingForceReset;
    quizCardContentScalePendingForceReset = false;
    quizCardLayoutSettlePassRunning = true;
    try {
        scheduleQuizCardHeightNormalization();
        scheduleQuizCardContentScaleSync(forceReset ? { forceReset: true } : {});
        // Direct, not scheduled: guarantees the dock is un-parked in this pass.
        positionQuickActionsDock();
        syncQuizCompanionVerticalGeometry();
    } finally {
        quizCardLayoutSettlePassRunning = false;
    }
}

function deferQuizCardWorkForPaneTransition() {
    if (!isQuizPaneLayoutTransitioning()) return false;
    window.whenPaneLayoutSettled?.(runQuizCardLayoutSettlePass);
    return true;
}


function measureQuickActionsAnchorCenter(cardRect, anchorEl, quizContent) {
    if (!anchorEl || !cardRect) return Math.round((cardRect?.height || 0) / 2);

    const anchorRect = anchorEl.getBoundingClientRect();
    if (!(anchorRect.height > 0)) return Math.round((cardRect.height || 0) / 2);

    let anchorCenter = Math.round((anchorRect.top + (anchorRect.height / 2)) - cardRect.top);

    // Keep the dock aligned to the progress row's natural spot inside the card,
    // instead of letting inner content scroll drag the trigger up and down.
    if (quizContent?.contains(anchorEl)) {
        anchorCenter += Math.round(quizContent.scrollTop || 0);
    }

    return anchorCenter;
}

function syncQuickActionsStageOwnership() {
    const stage = document.getElementById('work-area')?.dataset.memoraStage;
    if (!stage || stage === 'quiz') {
        scheduleQuickActionsDockPosition();
        return false;
    }
    cancelAnimationFrame(quickActionsDockPositionRaf);
    cancelAnimationFrame(quickActionsDockTrackRaf);
    quickActionsDockPositionRaf = 0;
    quickActionsDockTrackRaf = 0;
    quickActionsDockTrackUntil = 0;
    const dock = document.getElementById('quiz-quick-actions-dock');
    if (dock) {
        dock.style.visibility = 'hidden';
        dock.style.pointerEvents = 'none';
    }
    return true;
}

function positionQuickActionsDock() {
    const stage = document.getElementById('work-area')?.dataset.memoraStage;
    if (stage && stage !== 'quiz') { syncQuickActionsStageOwnership(); return; }
    const dock = els.quickActionsDock || $('quiz-quick-actions-dock');
    const quizCard = els.quizCard || $('quiz-card');
    const quizContent = els.quizContent || $('quiz-content-wrapper');
    if (!dock || !quizCard || !quizContent) return;
    const menu = els.quickActionsMenu || $('quiz-quick-actions-menu');
    const resetMenuPlacement = () => {
        if (!menu) return;
        menu.style.left = '';
        menu.style.right = '';
        menu.style.top = '';
        menu.style.bottom = '';
        menu.removeAttribute('data-placement');
    };
    if (dock.classList.contains('quiz-quick-actions-inline')) {
        dock.style.top = '';
        dock.style.left = '';
        dock.style.visibility = '';
        dock.style.pointerEvents = '';
        resetMenuPlacement();
        return;
    }
    // The rail mounts the dock on the card itself (app.live-left-rail-host.js). CSS hangs it off
    // the card's right edge, so it rides the card's glide and width in the same frame, even when
    // the main thread is busy; only its height along that edge is placed here.
    const cardMounted = dock.parentElement === quizCard;
    // On the card, CSS carries the tab through every frame of a transition; nothing to chase.
    if (cardMounted && quizCompanionFollowRunning) return;
    if (isQuizPaneLayoutTransitioning()) {
        // The companion follower moves the dock with the card for this transition.
        if (quizCompanionFollowFrame) return;
        // Chasing the card mid-transition costs two forced layouts per frame.
        if (!cardMounted) {
            dock.style.visibility = 'hidden';
            dock.style.pointerEvents = 'none';
        }
        window.whenPaneLayoutSettled?.(runQuizCardLayoutSettlePass);
        return;
    }
    if (document.body?.classList?.contains('pdf-expanded-mode')
        || document.body?.classList?.contains('ai-expl-slide-modal-open')) {
        dock.style.visibility = 'hidden';
        dock.style.pointerEvents = 'none';
        return;
    }
    if (getComputedStyle(quizContent).display === 'none') {
        dock.style.visibility = 'hidden';
        dock.style.pointerEvents = 'none';
        return;
    }

    const cardRect = quizCard.getBoundingClientRect();
    const ownerRect = $('quiz-pane')?.getBoundingClientRect?.();
    const ownerHasGeometry = !!ownerRect && ownerRect.width > 0 && ownerRect.height > 0;
    const cardHeight = Math.round(cardRect.height || quizCard.clientHeight || quizCard.offsetHeight || 0);
    const cardWidth = Math.round(cardRect.width || quizCard.clientWidth || quizCard.offsetWidth || 0);
    if (!cardHeight || !cardWidth
        || (!cardMounted && (cardRect.bottom <= 0 || cardRect.top >= window.innerHeight))) {
        dock.style.visibility = 'hidden';
        dock.style.pointerEvents = 'none';
        return;
    }

    dock.style.visibility = '';
    dock.style.pointerEvents = '';

    const triggerHeight = Math.max(
        Math.round((els.quickActionsTrigger?.offsetHeight || 0)),
        34
    );
    const halfTriggerHeight = Math.round(triggerHeight / 2);
    const progressText = els.prog || $('progress-text');
    const anchorEl = document.querySelector('#quiz-card .quiz-top-controls-row')
        || (dock.dataset.anchorId ? $(dock.dataset.anchorId) : null)
        || progressText;
    let anchorCenter = Math.round(cardHeight / 2);

    if (anchorEl) {
        anchorCenter = measureQuickActionsAnchorCenter(cardRect, anchorEl, quizContent);
    }

    const compactViewport = window.innerWidth <= 700;
    // The dock is centred on `top`. Beside the card the Tools tab hangs from the study
    // controls' centre line instead, so it starts level with them as in the prototype.
    const tabDrop = compactViewport ? 0 : halfTriggerHeight;
    if (cardMounted) {
        // Card-relative (the absolute dock's box is the card's padding box). The anchor sits in
        // the zoomed #quiz-scale-shell, so its offset is a fixed part plus a part that scales with
        // --quiz-content-scale. Written that way, CSS keeps the tab on the controls' centre line
        // through a scale transition with no per-frame measuring (app.live-left-rail-host.js).
        const shell = els.quizScaleShell || $('quiz-scale-shell');
        const scale = parseFloat(getComputedStyle(quizCard).getPropertyValue('--quiz-content-scale')) || 1;
        const shellOffset = shell ? shell.getBoundingClientRect().top - cardRect.top : 0;
        const topBase = `${Math.round((shellOffset + tabDrop - (quizCard.clientTop || 0)) * 100) / 100}px`;
        const topScaled = `${Math.round(((anchorCenter - shellOffset) / scale) * 100) / 100}px`;
        if (dock.style.getPropertyValue('--quiz-dock-top-base') !== topBase) dock.style.setProperty('--quiz-dock-top-base', topBase);
        if (dock.style.getPropertyValue('--quiz-dock-top-scaled') !== topScaled) dock.style.setProperty('--quiz-dock-top-scaled', topScaled);
        if (dock.style.top) dock.style.top = '';
        if (dock.style.left) dock.style.left = '';
        // A compact viewport tucks the tab inside the card's edge (CSS), over the progress row. So
        // does a card that runs too close to the window's right edge (a 768px iPad with the rail
        // expanded), where a tab hung outside the card would be cut off by the screen.
        const dockSpan = Math.max(34, Math.round(dock.offsetWidth || 0));
        const tucked = !compactViewport && Math.round(cardRect.right) + dockSpan > window.innerWidth - 4;
        if (tucked !== dock.classList.contains('quiz-dock-tucked')) dock.classList.toggle('quiz-dock-tucked', tucked);
        const overlapsCard = compactViewport || tucked;
        if (overlapsCard !== document.body.classList.contains('quiz-dock-overlaps-card')) {
            document.body.classList.toggle('quiz-dock-overlaps-card', overlapsCard);
        }
        const mountedReserve = `${dockSpan + 12}px`;
        if (quizCard.style.getPropertyValue('--quiz-dock-reserve') !== mountedReserve) {
            quizCard.style.setProperty('--quiz-dock-reserve', mountedReserve);
        }
        placeQuickActionsMenu(menu, ownerRect, ownerHasGeometry);
        return;
    }
    const top = clampNum(
        Math.round(cardRect.top + anchorCenter + tabDrop),
        halfTriggerHeight + 8,
        Math.max(halfTriggerHeight + 8, window.innerHeight - halfTriggerHeight - 8)
    );
    const dockWidth = Math.max(
        Math.round(dock.offsetWidth || 0),
        compactViewport ? 34 : 0
    );
    const outsideLeft = Math.round(cardRect.right - 1);
    const insideLeft = Math.round(cardRect.right - Math.max(34, dockWidth) - 1);
    const unclampedLeft = compactViewport ? insideLeft : outsideLeft;
    const dockSpan = Math.max(34, dockWidth);
    const ownerLeft = ownerHasGeometry ? Math.max(8, Math.round(ownerRect.left) + 8) : 8;
    const ownerRight = ownerHasGeometry
        ? Math.min(window.innerWidth - 8, Math.round(ownerRect.right) - 8)
        : window.innerWidth - 8;
    const left = clampNum(
        unclampedLeft,
        ownerLeft,
        Math.max(ownerLeft, ownerRight - dockSpan)
    );

    dock.style.top = `${Math.round(top)}px`;
    dock.style.left = `${Math.round(left)}px`;

    // The dock can land visually on top of the card here (MD-09): the clamp
    // above pulls an off-card `outsideLeft` position back onto a narrow
    // viewport. Flag that on <body> so CSS can reserve room for anything the
    // dock would otherwise cover, like the progress counter.
    const dockReserve = Math.max(34, dockWidth) + 12;
    const dockOverlapsCard = (left + Math.max(34, dockWidth)) > (cardRect.right - 4);
    if (dockOverlapsCard !== document.body.classList.contains('quiz-dock-overlaps-card')) {
        document.body.classList.toggle('quiz-dock-overlaps-card', dockOverlapsCard);
    }
    // Writing a custom property to <body> on every dock-tracking frame invalidates inherited
    // style for the whole document. The only consumer is .quiz-progress-text inside the card,
    // so scope the variable to the card subtree and let style recalc stop there.
    quizCard.style.setProperty('--quiz-dock-reserve', `${dockReserve}px`);
    placeQuickActionsMenu(menu, ownerRect, ownerHasGeometry);
}

// The menu is portaled with the dock, so a fixed left edge is not safe when
// the quiz pane is narrow or the card sits near the visual viewport edge.
// Re-measure the open menu after the dock lands and keep it inside both the
// current viewport and its owning quiz pane. Phone layouts retain their
// existing inline/right-aligned CSS path in positionQuickActionsDock.
function placeQuickActionsMenu(menu, ownerRect, ownerHasGeometry) {
    const dock = els.quickActionsDock || $('quiz-quick-actions-dock');
    if (!dock || !menu || menu.hidden || getComputedStyle(menu).display === 'none') return;
    const menuRect = menu.getBoundingClientRect();
    const triggerRect = (els.quickActionsTrigger || $('quiz-quick-actions-trigger'))?.getBoundingClientRect?.();
    const dockRect = dock.getBoundingClientRect();
    if (!triggerRect || !menuRect.width || !menuRect.height || !dockRect.width) return;

    const viewport = window.visualViewport;
    const viewportLeft = Number(viewport?.offsetLeft) || 0;
    const viewportTop = Number(viewport?.offsetTop) || 0;
    const viewportWidth = Number(viewport?.width) || window.innerWidth;
    const viewportHeight = Number(viewport?.height) || window.innerHeight;
    const viewportRight = viewportLeft + viewportWidth;
    const viewportBottom = viewportTop + viewportHeight;
    const safeMargin = 12;
    const safeLeft = Math.max(
        viewportLeft + safeMargin,
        ownerHasGeometry ? ownerRect.left + safeMargin : viewportLeft + safeMargin
    );
    const safeRight = Math.min(
        viewportRight - safeMargin,
        ownerHasGeometry ? ownerRect.right - safeMargin : viewportRight - safeMargin
    );
    const horizontalLeft = safeRight - safeLeft >= menuRect.width
        ? safeLeft
        : viewportLeft + safeMargin;
    const horizontalRight = safeRight - safeLeft >= menuRect.width
        ? safeRight
        : viewportRight - safeMargin;
    const maxLeft = Math.max(horizontalLeft, horizontalRight - menuRect.width);
    // Beside the card the panel opens from the Tools tab over the card's edge, top-aligned
    // with the tab. A compact viewport keeps the tab on the card and drops the panel below.
    const sideOpening = window.innerWidth > 700;
    const spaceRight = horizontalRight - triggerRect.right;
    const spaceLeft = triggerRect.left - horizontalLeft;
    const preferredLeft = sideOpening
        ? triggerRect.left - menuRect.width
        : (spaceRight >= menuRect.width || spaceRight >= spaceLeft
            ? triggerRect.left
            : triggerRect.right - menuRect.width);
    const menuLeft = clampNum(preferredLeft, horizontalLeft, maxLeft);

    const verticalTop = Math.max(
        viewportTop + safeMargin,
        ownerHasGeometry ? ownerRect.top + safeMargin : viewportTop + safeMargin
    );
    const verticalBottom = Math.min(
        viewportBottom - safeMargin,
        ownerHasGeometry ? ownerRect.bottom - safeMargin : viewportBottom - safeMargin
    );
    const maxTop = Math.max(verticalTop, verticalBottom - menuRect.height);
    const gap = 8;
    const availableBelow = verticalBottom - triggerRect.bottom - gap;
    const availableAbove = triggerRect.top - verticalTop - gap;
    const openAbove = !sideOpening && availableBelow < menuRect.height && availableAbove > availableBelow;
    const preferredTop = sideOpening
        ? triggerRect.top
        : (openAbove
            ? triggerRect.top - menuRect.height - gap
            : triggerRect.bottom + gap);
    const menuTop = clampNum(preferredTop, verticalTop, maxTop);

    menu.style.left = `${Math.round(menuLeft - dockRect.left)}px`;
    menu.style.right = 'auto';
    menu.style.top = `${Math.round(menuTop - dockRect.top)}px`;
    menu.style.bottom = 'auto';
    menu.dataset.placement = sideOpening
        ? 'side-left'
        : `${openAbove ? 'top' : 'bottom'}-${menuLeft < triggerRect.left ? 'right' : 'left'}`;
}

function scheduleQuickActionsDockPosition() {
    const stage = document.getElementById('work-area')?.dataset.memoraStage;
    if (stage && stage !== 'quiz') { syncQuickActionsStageOwnership(); return; }
    if (quickActionsDockPositionRaf) cancelAnimationFrame(quickActionsDockPositionRaf);
    quickActionsDockPositionRaf = requestAnimationFrame(() => {
        quickActionsDockPositionRaf = 0;
        positionQuickActionsDock();
    });
}

function trackQuickActionsDockPosition(durationMs = QUICK_ACTIONS_DOCK_LAYOUT_TRACK_MS) {
    const dock = els.quickActionsDock || $('quiz-quick-actions-dock');
    if (dock && dock.parentElement === (els.quizCard || $('quiz-card'))) {
        // Mounted on the card, the tab moves with it in CSS; one placement after the change will do.
        clearTimeout(trackQuickActionsDockPosition.settleTimer);
        trackQuickActionsDockPosition.settleTimer = window.setTimeout(
            scheduleQuickActionsDockPosition,
            Math.max(120, Number(durationMs) || QUICK_ACTIONS_DOCK_LAYOUT_TRACK_MS)
        );
        return;
    }
    if (isQuizPaneLayoutTransitioning()) {
        // positionQuickActionsDock parks the dock and queues the settle pass.
        positionQuickActionsDock();
        return;
    }
    const stage = document.getElementById('work-area')?.dataset.memoraStage;
    if (stage && stage !== 'quiz') { syncQuickActionsStageOwnership(); return; }
    const now = performance.now();
    const duration = Math.max(120, Number(durationMs) || QUICK_ACTIONS_DOCK_LAYOUT_TRACK_MS);
    quickActionsDockTrackUntil = Math.max(quickActionsDockTrackUntil, now + duration);

    if (quickActionsDockTrackRaf) return;

    const tick = () => {
        quickActionsDockTrackRaf = 0;
        positionQuickActionsDock();

        if (performance.now() < quickActionsDockTrackUntil) {
            quickActionsDockTrackRaf = requestAnimationFrame(tick);
        }
    };

    quickActionsDockTrackRaf = requestAnimationFrame(tick);
}

/* The header shows the lecture a question came from. The question's own source file is
   the most specific name; its linked PDF stands in when a set carries no file name. */
function getQuizCardSourceLabel() {
    try {
        const realIdx = typeof filteredIndices !== 'undefined' && Array.isArray(filteredIndices)
            ? filteredIndices[currentQIndex]
            : currentQIndex;
        const q = Number.isInteger(realIdx) && typeof questions !== 'undefined' ? questions[realIdx] : null;
        if (!q || typeof q !== 'object') return '';
        let raw = String(q.sourceFile || q.src || '').trim();
        if (!raw && typeof findBestPdfForQuestion === 'function') raw = String(findBestPdfForQuestion(q) || '').trim();
        if (!raw) return '';
        const name = typeof getSessionFileDisplayName === 'function' ? getSessionFileDisplayName(raw) : raw;
        return String(name || raw).replace(/\.(pdf|json|txt|md|docx?|pptx?)$/i, '').trim();
    } catch (_) {
        return '';
    }
}

/* Source conflict flag. Quiz Gen's answer check writes question.sourceConflict on the rare
   question whose lecture claim clearly conflicts with current medical knowledge. A muted flag
   at the start of the header opens a short note on hover, click or tap; the question, its key
   and grading are untouched, and a question without the note shows nothing. */
const QUIZ_SOURCE_CONFLICT_KIND_LABELS = Object.freeze({
    outdated: 'Outdated in this source',
    error: 'Likely error in this source'
});

function setQuizSourceConflictNoteOpen(wrap, open, { pinned = false } = {}) {
    const note = wrap?.querySelector('.quiz-source-conflict-note');
    const flag = wrap?.querySelector('.quiz-source-conflict-flag');
    if (!note || !flag) return;
    note.hidden = !open;
    flag.setAttribute('aria-expanded', String(open));
    wrap.dataset.pinned = open && pinned ? '1' : '';
}

function createQuizSourceConflictFlag(heading) {
    const wrap = document.createElement('span');
    wrap.className = 'quiz-source-conflict';
    wrap.hidden = true;
    wrap.innerHTML = `<button type="button" class="quiz-source-conflict-flag" aria-expanded="false" aria-controls="quiz-source-conflict-note"
        aria-label="Source note: this differs from current medical knowledge" title="Source note">
        <svg viewBox="0 0 16 16" width="17" height="17" aria-hidden="true" focusable="false"><path d="M3.75 14.25V2.25M3.75 2.75h7.5l-1.75 2.75 1.75 2.75h-7.5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </button>
    <div id="quiz-source-conflict-note" class="quiz-source-conflict-note" role="note" hidden>
        <p class="quiz-source-conflict-kind"></p>
        <dl>
            <dt>Source says</dt><dd data-field="source"></dd>
            <dt>Current understanding</dt><dd data-field="current"></dd>
            <dt>For your exam</dt><dd data-field="exam"></dd>
            <dt data-ref>Reference</dt><dd data-field="ref" data-ref></dd>
        </dl>
    </div>`;
    const flag = wrap.querySelector('.quiz-source-conflict-flag');
    const isOpen = () => !wrap.querySelector('.quiz-source-conflict-note').hidden;
    // A mouse previews on hover; a click or tap pins the note until it is dismissed.
    wrap.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && !isOpen()) setQuizSourceConflictNoteOpen(wrap, true);
    });
    wrap.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse' && wrap.dataset.pinned !== '1') setQuizSourceConflictNoteOpen(wrap, false);
    });
    flag.addEventListener('click', (event) => {
        event.stopPropagation();
        const pinned = wrap.dataset.pinned === '1';
        setQuizSourceConflictNoteOpen(wrap, !pinned, { pinned: !pinned });
    });
    document.addEventListener('pointerdown', (event) => {
        if (isOpen() && !wrap.contains(event.target)) setQuizSourceConflictNoteOpen(wrap, false);
    });
    // Window capture runs ahead of the rail router's Escape handling, so Escape closes only the note.
    window.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !isOpen()) return;
        event.preventDefault();
        event.stopPropagation();
        setQuizSourceConflictNoteOpen(wrap, false);
        if (wrap.contains(document.activeElement)) flag.focus({ preventScroll: true });
    }, true);
    heading.insertBefore(wrap, heading.firstChild);
    return wrap;
}

function syncQuizSourceConflictFlag() {
    const heading = document.querySelector('#quiz-card .quiz-card-heading');
    if (!heading) return;
    let wrap = heading.querySelector(':scope > .quiz-source-conflict');
    let realIdx = null;
    let conflict = null;
    try {
        realIdx = typeof filteredIndices !== 'undefined' && Array.isArray(filteredIndices)
            ? filteredIndices[currentQIndex]
            : currentQIndex;
        conflict = typeof questions !== 'undefined' ? questions[realIdx]?.sourceConflict : null;
    } catch (_) {
        conflict = null;
    }
    const valid = conflict && typeof conflict === 'object'
        && ['source', 'current', 'exam'].every((field) => String(conflict[field] || '').trim());
    if (!valid) {
        if (wrap && !wrap.hidden) {
            setQuizSourceConflictNoteOpen(wrap, false);
            wrap.hidden = true;
            wrap.dataset.signature = '';
        }
        return;
    }
    if (!wrap) wrap = createQuizSourceConflictFlag(heading);
    const signature = `${realIdx}|${JSON.stringify(conflict)}`;
    if (wrap.dataset.signature !== signature) {
        wrap.dataset.signature = signature;
        setQuizSourceConflictNoteOpen(wrap, false);
        wrap.querySelector('.quiz-source-conflict-kind').textContent = QUIZ_SOURCE_CONFLICT_KIND_LABELS[conflict.kind]
            || QUIZ_SOURCE_CONFLICT_KIND_LABELS.outdated;
        ['source', 'current', 'exam', 'ref'].forEach((field) => {
            wrap.querySelector(`[data-field="${field}"]`).textContent = String(conflict[field] || '').trim();
        });
        const hasRef = !!String(conflict.ref || '').trim();
        wrap.querySelectorAll('[data-ref]').forEach((node) => { node.hidden = !hasRef; });
    }
    wrap.hidden = false;
}

/* The core render writes "Question 3 of 13" into #progress-text. That text stays for
   assistive tech and existing readers; the header paints the compact "3 / 13" from
   data-short. Choice labels likewise keep "A." while the badge paints just the letter. */
function syncQuizCardHeader() {
    const progressText = $('progress-text');
    if (progressText) {
        const text = String(progressText.textContent || '').trim();
        const match = text.match(/^Question\s+(\d+)\s+of\s+(\d+)$/i);
        const short = match ? (hasHighYieldQuizLabels() ? `${match[1]}/${match[2]}` : `${match[1]} / ${match[2]}`) : text;
        if (progressText.dataset.short !== short) progressText.dataset.short = short;
    }
    const source = document.querySelector('#quiz-card .quiz-card-source');
    if (source) {
        const label = getQuizCardSourceLabel();
        if (source.textContent !== label) source.textContent = label;
        if (source.title !== label) source.title = label;
    }
    document.querySelectorAll('#choices .choice > .label').forEach((label) => {
        const letter = String(label.textContent || '').trim().replace(/\.$/, '');
        if (label.dataset.letter !== letter) label.dataset.letter = letter;
    });
    syncQuizSourceConflictFlag();
    syncQuizQuestionJumpMenu();
}

function syncQuizQuestionJumpMenu() {
    const jump = $('jump-select');
    const menu = $('quiz-question-jump-menu');
    const trigger = $('quiz-question-jump-trigger');
    if (!jump || !menu || !trigger) return;
    const options = [...jump.options];
    const signature = options.map((option) => `${option.value}:${option.textContent}`).join('|');
    if (menu.dataset.optionsSignature !== signature) {
        menu.replaceChildren(...options.map((option) => {
            const item = document.createElement('button');
            item.type = 'button';
            item.className = 'quiz-question-jump-item';
            item.setAttribute('role', 'option');
            item.dataset.value = option.value;
            item.textContent = option.textContent;
            return item;
        }));
        menu.dataset.optionsSignature = signature;
    }
    menu.querySelectorAll('.quiz-question-jump-item').forEach((item) => {
        const current = item.dataset.value === jump.value;
        item.classList.toggle('is-current', current);
        item.setAttribute('aria-selected', String(current));
    });
    trigger.disabled = jump.disabled || options.length === 0;
    trigger.setAttribute('aria-label', `Choose question. ${$('progress-text')?.textContent || ''}`);
}

function setupQuizQuestionJumpMenu(countJump, jumpSelect) {
    let trigger = countJump.querySelector('#quiz-question-jump-trigger');
    if (!trigger) {
        trigger = document.createElement('button');
        trigger.id = 'quiz-question-jump-trigger';
        trigger.type = 'button';
        trigger.setAttribute('aria-haspopup', 'listbox');
        trigger.setAttribute('aria-expanded', 'false');
        countJump.appendChild(trigger);
    }
    let menu = countJump.querySelector('#quiz-question-jump-menu');
    if (!menu) {
        menu = document.createElement('div');
        menu.id = 'quiz-question-jump-menu';
        menu.setAttribute('role', 'listbox');
        menu.setAttribute('aria-label', 'Questions');
        menu.hidden = true;
        countJump.appendChild(menu);
    }
    const close = () => {
        menu.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
    };
    if (countJump.dataset.jumpMenuBound !== '1') {
        countJump.dataset.jumpMenuBound = '1';
        trigger.addEventListener('click', () => {
            syncQuizQuestionJumpMenu();
            menu.hidden = !menu.hidden;
            trigger.setAttribute('aria-expanded', String(!menu.hidden));
            if (!menu.hidden) menu.querySelector('.is-current')?.scrollIntoView?.({ block: 'nearest' });
        });
        trigger.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowDown') return;
            event.preventDefault();
            event.stopPropagation();
            if (menu.hidden) trigger.click();
            (menu.querySelector('.is-current') || menu.querySelector('.quiz-question-jump-item'))?.focus();
        });
        menu.addEventListener('click', (event) => {
            const item = event.target.closest('.quiz-question-jump-item');
            if (!item) return;
            jumpSelect.value = item.dataset.value;
            jumpSelect.dispatchEvent(new Event('change', { bubbles: true }));
            close();
            trigger.focus({ preventScroll: true });
        });
        countJump.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && !menu.hidden) {
                event.preventDefault();
                close();
                trigger.focus({ preventScroll: true });
            } else if (!menu.hidden && ['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
                event.preventDefault();
                const items = [...menu.querySelectorAll('.quiz-question-jump-item')];
                const index = items.indexOf(document.activeElement);
                const next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1
                    : Math.max(0, Math.min(items.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)));
                items[next]?.focus();
            }
        });
    }
    if (!document.documentElement.dataset.quizJumpDismissBound) {
        document.documentElement.dataset.quizJumpDismissBound = '1';
        document.addEventListener('pointerdown', (event) => {
            const current = document.querySelector('#quiz-card .quiz-count-jump');
            if (current?.contains(event.target)) return;
            const currentMenu = $('quiz-question-jump-menu');
            const currentTrigger = $('quiz-question-jump-trigger');
            if (currentMenu) currentMenu.hidden = true;
            currentTrigger?.setAttribute('aria-expanded', 'false');
        });
    }
    syncQuizQuestionJumpMenu();
}

let quizCardHeaderObserver = null;
function bindQuizCardHeaderSync() {
    const progressText = $('progress-text');
    if (!quizCardHeaderObserver && progressText && typeof MutationObserver === 'function') {
        quizCardHeaderObserver = new MutationObserver(syncQuizCardHeader);
        quizCardHeaderObserver.observe(progressText, { childList: true, characterData: true, subtree: true });
        const choices = $('choices');
        if (choices) quizCardHeaderObserver.observe(choices, { childList: true });
        const jumpSelect = $('jump-select');
        if (jumpSelect) quizCardHeaderObserver.observe(jumpSelect, {
            childList: true, subtree: true, attributes: true, attributeFilter: ['disabled']
        });
    }
    syncQuizCardHeader();
}

/* The toolbar keeps only the four study controls, so Refresh Question / Refresh Quiz
   move into Tools. The native buttons stay authoritative and these items click them. */
function ensureQuickActionsRefreshItems(dock) {
    const menu = dock?.querySelector('#quiz-quick-actions-menu');
    if (!menu) return;
    [['refresh-question', 'Refresh Question', 'Reset and reshuffle this question (U)'],
        ['refresh-quiz', 'Refresh Quiz', 'Reset and reshuffle the whole quiz']].forEach(([action, label, title]) => {
        if (menu.querySelector(`[data-quick-action="${action}"]`)) return;
        const item = document.createElement('button');
        item.type = 'button';
        item.className = 'quiz-quick-action-btn';
        item.dataset.quickAction = action;
        item.setAttribute('role', 'menuitem');
        item.title = title;
        item.innerHTML = `<span class="gradient-text">${label}</span>`;
        menu.appendChild(item);
    });
}

/* Tools reads as three labelled groups, as in the prototype. Items are moved rather than
   rebuilt, so every native handler and the study-mode items added by the rail polish keep
   working; anything not listed here stays above the groups. Phone keeps its flat list. */
const QUICK_ACTION_MENU_GROUPS = Object.freeze([
    ['Question', ['[data-quick-action="regenerate"]', '[data-quick-action="mix"]', '[data-quick-action="shuffle"]',
        '[data-quick-action="refresh-question"]', '[data-quick-action="refresh-quiz"]']],
    ['Study', ['[data-quick-action="exam"]', '[data-quick-action="hard"]', '[data-memora-study-mode="srs-mode-btn"]',
        '[data-memora-study-mode="game-mode-toggle"]']]
]);
function arrangeQuickActionsMenuGroups(menu) {
    menu.querySelectorAll(':scope > .quiz-quick-action-group-label, :scope > .quiz-quick-action-separator')
        .forEach((node) => node.remove());
    if (document.documentElement.classList.contains('phone-device')) return;
    let placedGroup = false;
    QUICK_ACTION_MENU_GROUPS.forEach(([label, selectors]) => {
        const items = selectors.map((selector) => menu.querySelector(`:scope > ${selector}`)).filter(Boolean);
        if (!items.length) return;
        if (placedGroup) {
            const separator = document.createElement('div');
            separator.className = 'quiz-quick-action-separator';
            separator.setAttribute('role', 'separator');
            menu.appendChild(separator);
        }
        const heading = document.createElement('div');
        heading.className = 'quiz-quick-action-group-label';
        heading.setAttribute('role', 'presentation');
        heading.textContent = label;
        menu.appendChild(heading);
        items.forEach((item) => menu.appendChild(item));
        placedGroup = true;
    });
}

function ensureQuizQuickActionsMarkup() {
    const progressText = $('progress-text');
    const row = document.querySelector('#quiz-card .quiz-top-controls-row') || progressText?.parentElement;
    if (!row) return;

    row.classList.add('quiz-top-controls-row');
    if (progressText && !progressText.classList.contains('quiz-progress-text')) {
        progressText.classList.add('quiz-progress-text');
    }
    if (progressText) progressText.setAttribute('data-testid', 'quiz-progress');
    if (progressText && !$('quiz-high-yield-count')) {
        const highYieldCount = document.createElement('span');
        highYieldCount.id = 'quiz-high-yield-count';
        highYieldCount.className = 'quiz-high-yield-count';
        highYieldCount.hidden = true;
        progressText.insertAdjacentElement('afterend', highYieldCount);
    }

    let dock = $('quiz-quick-actions-dock');
    if (!dock) {
        dock = document.createElement('div');
        dock.id = 'quiz-quick-actions-dock';
        dock.className = 'quiz-quick-actions-dock';
        dock.dataset.anchorId = 'progress-text';
        dock.setAttribute('aria-label', 'Quiz tools');
        dock.setAttribute('data-testid', 'quick-dock');
        dock.innerHTML = `
            <button type="button" id="quiz-quick-actions-trigger" class="quiz-quick-actions-trigger"
                data-testid="quick-dock-trigger" title="Quiz tools" aria-haspopup="menu" aria-expanded="false">
                <span class="quick-actions-bookmark" aria-hidden="true"></span>
                <span class="quick-actions-label">Tools</span>
            </button>
            <div id="quiz-quick-actions-menu" class="quiz-quick-actions-menu" data-testid="quick-dock-menu" role="menu" hidden>
                <button type="button" class="quiz-quick-action-btn" data-testid="quick-dock-action-notes" data-quick-action="notes" role="menuitem">
                    <span class="gradient-text">Notes</span>
                </button>
                <button type="button" class="quiz-quick-action-btn" data-testid="quick-dock-action-saved" data-quick-action="saved" role="menuitem">
                    <span class="gradient-text">Saved Questions</span>
                </button>
                <button type="button" class="quiz-quick-action-btn" data-testid="quick-dock-action-regenerate" data-quick-action="regenerate" role="menuitem">
                    <span class="gradient-text">Regenerate Question</span>
                </button>
                <button type="button" class="quiz-quick-action-btn" data-testid="quick-dock-action-mix" data-quick-action="mix" role="menuitem">
                    <span class="gradient-text">Mix Answers</span>
                </button>
                <button type="button" class="quiz-quick-action-btn" data-quick-action="exam" role="menuitem">
                    <span class="gradient-text">Exam mode</span>
                </button>
                <button type="button" class="quiz-quick-action-btn" data-testid="quick-dock-action-hard" data-quick-action="hard" role="menuitem">
                    <span class="gradient-text">Hard Mode</span>
                </button>
                <button type="button" class="quiz-quick-action-btn" data-testid="quick-dock-action-shuffle" data-quick-action="shuffle" role="menuitem">
                    <span class="gradient-text">Shuffle Questions</span>
                </button>
            </div>
        `;
        row.appendChild(dock);
    } else {
        dock.dataset.anchorId = 'progress-text';
        dock.setAttribute('data-testid', 'quick-dock');
        dock.querySelector('#quiz-quick-actions-trigger')?.setAttribute('data-testid', 'quick-dock-trigger');
        dock.querySelector('#quiz-quick-actions-menu')?.setAttribute('data-testid', 'quick-dock-menu');
        dock.setAttribute('aria-label', 'Quiz tools');
        const trigger = dock.querySelector('#quiz-quick-actions-trigger');
        if (trigger) {
            trigger.title = 'Quiz tools';
            const label = trigger.querySelector('.quick-actions-label');
            if (label) label.textContent = 'Tools';
        }
        dock.querySelector('[data-quick-action="notes"]')?.setAttribute('data-testid', 'quick-dock-action-notes');
        dock.querySelector('[data-quick-action="saved"]')?.setAttribute('data-testid', 'quick-dock-action-saved');
        dock.querySelector('[data-quick-action="regenerate"]')?.setAttribute('data-testid', 'quick-dock-action-regenerate');
        dock.querySelector('[data-quick-action="mix"]')?.setAttribute('data-testid', 'quick-dock-action-mix');
        dock.querySelector('[data-quick-action="hard"]')?.setAttribute('data-testid', 'quick-dock-action-hard');
        dock.querySelector('[data-quick-action="shuffle"]')?.setAttribute('data-testid', 'quick-dock-action-shuffle');
    }

    els.quickActionsDock = $('quiz-quick-actions-dock');
    els.quickActionsTrigger = $('quiz-quick-actions-trigger');
    els.quickActionsMenu = $('quiz-quick-actions-menu');
    // The Core / Extended / All picker beside the progress counter replaced this Tools item.
    els.quickActionsMenu?.querySelector('[data-quick-action="high-yield"]')?.remove();
    window.syncHighYieldQuizControls?.();
    const isPhone = document.documentElement.classList.contains('phone-device');
    const saveBtn = $('save-btn');
    const navRow = $('nav-row');
    const jumpSelect = $('jump-select');
    const scaleShell = $('quiz-scale-shell');
    const toolbarControls = row.querySelector('.quiz-toolbar-controls');
    let header = scaleShell?.querySelector(':scope > .quiz-card-header') || null;
    let eyebrow = scaleShell?.querySelector(':scope > .quiz-question-eyebrow') || null;
    let metaActions = document.querySelector('#quiz-card .quiz-question-meta-actions');
    const askInlineText = $('ask-memora-inline-btn')?.querySelector('.quick-control-text');

    // Desktop/iPad follow the study-surface prototype: a "Quiz · source" header holding the
    // count and Save, then the progress track, the four study controls, and a "Question"
    // eyebrow. The count opens the styled question list while the native select remains
    // the authoritative navigation control. Phone retains its established navigation row.
    if (!isPhone) {
        if (scaleShell && !header) {
            header = document.createElement('div');
            header.className = 'quiz-card-header';
            header.innerHTML = '<div class="quiz-card-heading"><span class="quiz-card-title">Quiz</span><span class="quiz-card-source"></span></div>';
            scaleShell.insertBefore(header, $('progress-bar-container') || scaleShell.firstChild);
        }
        if (!metaActions) {
            metaActions = document.createElement('div');
            metaActions.className = 'quiz-question-meta-actions';
        }
        if (header && metaActions.parentElement !== header) header.appendChild(metaActions);
        let progressSummary = metaActions.querySelector('.quiz-progress-summary');
        if (!progressSummary) {
            progressSummary = document.createElement('span');
            progressSummary.className = 'quiz-progress-summary';
            metaActions.insertBefore(progressSummary, metaActions.firstChild);
        }
        let countJump = metaActions.querySelector('.quiz-count-jump');
        if (!countJump) {
            countJump = document.createElement('span');
            countJump.className = 'quiz-count-jump';
            metaActions.insertBefore(countJump, metaActions.firstChild);
        }
        if (countJump.parentElement !== progressSummary) progressSummary.appendChild(countJump);
        const highYieldCount = $('quiz-high-yield-count');
        if (highYieldCount && highYieldCount.parentElement !== progressSummary) progressSummary.appendChild(highYieldCount);
        if (progressText && progressText.parentElement !== countJump) countJump.insertBefore(progressText, countJump.firstChild);
        if (jumpSelect && jumpSelect.parentElement !== countJump) countJump.appendChild(jumpSelect);
        if (jumpSelect) {
            jumpSelect.setAttribute('aria-hidden', 'true');
            jumpSelect.tabIndex = -1;
            setupQuizQuestionJumpMenu(countJump, jumpSelect);
        }
        if (saveBtn && saveBtn.parentElement !== metaActions) metaActions.appendChild(saveBtn);
        saveBtn?.classList.add('quiz-save-inline');
        if (scaleShell && !eyebrow) {
            eyebrow = document.createElement('div');
            eyebrow.className = 'quiz-question-eyebrow';
            eyebrow.setAttribute('aria-hidden', 'true');
            eyebrow.textContent = 'Question';
            scaleShell.insertBefore(eyebrow, $('q-image') || $('question'));
        }
        if (askInlineText) askInlineText.textContent = 'Ask';
        ensureQuickActionsRefreshItems(dock);
        bindQuizCardHeaderSync();
    } else {
        if (askInlineText) askInlineText.textContent = 'Ask';
        if (jumpSelect && toolbarControls && jumpSelect.parentElement !== toolbarControls) {
            toolbarControls.insertBefore(jumpSelect, toolbarControls.firstChild);
        }
        jumpSelect?.removeAttribute('aria-hidden');
        jumpSelect?.removeAttribute('tabindex');
        if (progressText && progressText.parentElement !== row) row.appendChild(progressText);
        if (saveBtn && navRow && saveBtn.parentElement !== navRow) {
            navRow.insertBefore(saveBtn, $('next-btn') || null);
        }
        saveBtn?.classList.remove('quiz-save-inline');
        dock?.querySelectorAll('[data-quick-action^="refresh-"]').forEach((item) => item.remove());
        metaActions?.remove();
        header?.remove();
        eyebrow?.remove();
    }
    if (isPhone && els.quickActionsTrigger && els.quickActionsTrigger.dataset.phoneSkin !== '1') {
        els.quickActionsTrigger.dataset.phoneSkin = '1';
        els.quickActionsTrigger.innerHTML = `
            <span class="gradient-text quick-control-label">
                <svg class="quick-control-svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <defs>
                        <linearGradient id="quick-actions-grad" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" stop-color="var(--g1, #60a5fa)" />
                            <stop offset="100%" stop-color="var(--g2, #f472b6)" />
                        </linearGradient>
                    </defs>
                    <path d="M13 2.5 L5 13.5 h5.4 L9.2 21.5 L19 10.2 h-5.6 Z" fill="none"
                        stroke="url(#quick-actions-grad)" stroke-width="2.1"
                        stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span class="quick-control-text">Tools</span>
            </span>`;
    }
    const toolbar = document.querySelector('.quiz-toolbar-controls');
    const notesBtn = $('notes-btn-inline');
    if (isPhone && toolbar && els.quickActionsDock) {
        if (els.quickActionsDock.parentElement !== toolbar) {
            toolbar.insertBefore(els.quickActionsDock, notesBtn || null);
        }
        els.quickActionsDock.classList.add('quiz-quick-actions-inline');
    } else if (document.body && els.quickActionsDock) {
        els.quickActionsDock.classList.remove('quiz-quick-actions-inline');
        // The left rail keeps the dock on the card (app.live-left-rail-host.js); leave it there.
        const railCardMounted = document.body.classList.contains('memora-live-left-rail-preview')
            && els.quickActionsDock.parentElement === (els.quizCard || $('quiz-card'));
        if (!railCardMounted && els.quickActionsDock.parentElement !== document.body) {
            document.body.appendChild(els.quickActionsDock);
        }
    }
    scheduleQuickActionsDockPosition();
}

// Only transitions of these properties can move the quiz card, and with it the dock.
const QUICK_ACTIONS_DOCK_GEOMETRY_TRANSITION = /^(?:all|width|height|min-|max-|left|top|right|bottom|inset|margin|padding|transform|translate|scale|rotate|grid|flex|gap|column|row|border(?:-\w+)?-width|font-size|line-height)/;

function bindQuickActionsDockTransitionTracking() {
    const trackTarget = (el) => {
        if (!el || el.dataset.quickDockTransitionTrackBound === '1') return;
        el.dataset.quickDockTransitionTrackBound = '1';
        ['transitionrun', 'transitionstart'].forEach((eventName) => {
            el.addEventListener(eventName, (event) => {
                // These events bubble from every descendant. Colour, opacity and shadow fades on
                // buttons and choices cannot move the card, yet each restarted the per-frame
                // tracking loop (~240 calls per pane open). Only this element's own geometry
                // is tracked frame by frame; a descendant's is settled once when it ends.
                if (event?.target !== el) return;
                if (!QUICK_ACTIONS_DOCK_GEOMETRY_TRANSITION.test(String(event?.propertyName || ''))) return;
                trackQuickActionsDockPosition();
            });
        });
        el.addEventListener('transitionend', (event) => {
            if (event?.target === el) return;
            if (!QUICK_ACTIONS_DOCK_GEOMETRY_TRANSITION.test(String(event?.propertyName || ''))) return;
            scheduleQuickActionsDockPosition();
        });
    };

    trackTarget(els?.workArea || $('work-area'));
    trackTarget($('quiz-pane'));
    trackTarget(els?.quizCard || $('quiz-card'));
}

const FLOATING_QUIZ_Z_INDEX = '3000';
const FLOATING_QUIZ_Z_INDEX_BELOW_DROPDOWNS = FLOATING_QUIZ_Z_INDEX;
var isQuizCardExpanded = false;
let quizCardExpandRestoreState = null;
let isQuizCardExpandLockOn = false; // Legacy inert slot; expansion no longer has a lock state.

function syncFloatingQuizLayering() {
    if (!els.quizCard || !els.quizCard.classList.contains('is-floating')) return;
    els.quizCard.style.zIndex = FLOATING_QUIZ_Z_INDEX_BELOW_DROPDOWNS;
}

/* Legacy function name retained because the classic-script bundle calls it from app.core.js.
   It now synchronizes the explicit expand/restore toggle; no Lock behavior remains. */
function syncQuizExpandLockButton() {
    const btn = els?.quizExpandLockBtn || $('quiz-expand-toggle-btn-inline');
    if (!btn) return;
    const expanded = !!isQuizCardExpanded;
    btn.classList.toggle('is-expanded', expanded);
    btn.setAttribute('aria-pressed', expanded ? 'true' : 'false');
    btn.setAttribute('aria-label', expanded ? 'Restore quiz size' : 'Expand quiz');
    btn.title = expanded ? 'Restore quiz size' : 'Expand quiz';
    const expandIcon = btn.querySelector('[data-expand-icon="expand"]');
    const restoreIcon = btn.querySelector('[data-expand-icon="restore"]');
    if (expanded) {
        expandIcon?.setAttribute('hidden', '');
        restoreIcon?.removeAttribute('hidden');
    } else {
        restoreIcon?.setAttribute('hidden', '');
        expandIcon?.removeAttribute('hidden');
    }
}

function setupQuizExpandLockButton() {
    const btn = els?.quizExpandLockBtn || $('quiz-expand-toggle-btn-inline');
    if (!btn || btn.dataset.expandToggleInit === '1') return;
    btn.dataset.expandToggleInit = '1';
    btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleQuizCardExpanded();
    });
    syncQuizExpandLockButton();
}

function handleQuestionNavigationFromExpandedQuizCard() {
    // Expanded mode persists across Previous/Next until the learner restores it or presses Escape.
    if (isQuizCardExpanded) syncQuizExpandLockButton();
}

/* Expanding the card can glide it between its slot and the expanded frame, with the Lecture
   Finder's expand motion. The expanded rules pin the frame with !important, so the glide drives
   inline !important geometry through a transition and hands the card back to CSS when it lands. */
const QUIZ_CARD_GLIDE_MS = 420;
const QUIZ_CARD_GLIDE_EASE = 'cubic-bezier(.22,1,.36,1)';
let quizCardGlideFinish = null;

function prefersReducedQuizCardMotion() {
    return !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
}

function glideQuizCardBetween(card, fromRect, toRect) {
    if (!card || !fromRect?.width || !fromRect?.height || !toRect?.width || !toRect?.height) return;
    const savedCssText = card.style.cssText;
    const place = (rect) => {
        card.style.setProperty('top', `${rect.top}px`, 'important');
        card.style.setProperty('left', `${rect.left}px`, 'important');
        card.style.setProperty('width', `${rect.width}px`, 'important');
        card.style.setProperty('height', `${rect.height}px`, 'important');
    };
    card.style.setProperty('transition', 'none', 'important');
    card.style.setProperty('position', 'fixed', 'important');
    card.style.setProperty('right', 'auto', 'important');
    card.style.setProperty('bottom', 'auto', 'important');
    card.style.setProperty('margin', '0', 'important');
    card.style.setProperty('max-width', 'none', 'important');
    card.style.setProperty('max-height', 'none', 'important');
    card.style.setProperty('box-sizing', 'border-box', 'important');
    card.style.setProperty('z-index', '12040', 'important');
    place(fromRect);
    card.getBoundingClientRect();
    card.style.setProperty('transition', ['top', 'left', 'width', 'height']
        .map((prop) => `${prop} ${QUIZ_CARD_GLIDE_MS}ms ${QUIZ_CARD_GLIDE_EASE}`).join(', '), 'important');
    place(toRect);

    let timer = 0;
    const finish = () => {
        if (quizCardGlideFinish !== finish) return;
        quizCardGlideFinish = null;
        clearTimeout(timer);
        card.removeEventListener('transitionend', onEnd);
        card.style.cssText = savedCssText;
        if (els.popup?.classList.contains('active') && currentPopupBtn) updatePopupPosition();
    };
    const onEnd = (event) => {
        if (event.target === card && (event.propertyName === 'width' || event.propertyName === 'height')) finish();
    };
    quizCardGlideFinish = finish;
    card.addEventListener('transitionend', onEnd);
    timer = setTimeout(finish, QUIZ_CARD_GLIDE_MS + 120);
}

/* A surface may ask the rail to step aside while the card is expanded (the session summary
   does). The hold ends with the expansion, whichever path collapses it, and any rail action
   other than full screen or search counts as moving away. */
let quizCardExpandRailRelease = null;
let quizCardExpandRailWatch = 0;

function onRailClickWhileQuizCardExpanded(event) {
    const action = event.target instanceof Element
        ? event.target.closest('#controls-bar [data-live-rail-action]')?.dataset.liveRailAction
        : '';
    if (!action || action === 'fullscreen' || action === 'search') return;
    // The rail acts on this click first; restoring the rail after it keeps its rows still under the pointer.
    setTimeout(() => { if (isQuizCardExpanded) toggleQuizCardExpanded(false); }, 0);
}

function holdRailForQuizCardExpand() {
    if (quizCardExpandRailRelease) return;
    const rail = window.MemoraLiveLeftRailPreview;
    const release = rail?.holdCompact?.();
    if (typeof release !== 'function') return;
    quizCardExpandRailRelease = release;
    rail.sync?.();
    window.addEventListener('click', onRailClickWhileQuizCardExpanded, true);
    const card = els?.quizCard || $('quiz-card');
    // Leaving the surface by any route that hides the card also ends the expansion.
    quizCardExpandRailWatch = setInterval(() => {
        if (!isQuizCardExpanded) releaseRailForQuizCardExpand();
        else if (!card?.isConnected || card.getClientRects().length === 0) toggleQuizCardExpanded(false);
    }, 400);
}

function releaseRailForQuizCardExpand() {
    if (!quizCardExpandRailRelease) return false;
    const release = quizCardExpandRailRelease;
    quizCardExpandRailRelease = null;
    clearInterval(quizCardExpandRailWatch);
    quizCardExpandRailWatch = 0;
    window.removeEventListener('click', onRailClickWhileQuizCardExpanded, true);
    release();
    window.MemoraLiveLeftRailPreview?.sync?.();
    return true;
}

function toggleQuizCardExpanded(force, options = {}) {
    const card = els?.quizCard || $('quiz-card');
    if (!card) return false;

    const next = force === undefined ? !isQuizCardExpanded : !!force;
    if (next === isQuizCardExpanded) return false;

    const glide = !!options.animate && !prefersReducedQuizCardMotion();
    // A toggle mid-glide starts from where the card is now.
    const glideFrom = glide ? card.getBoundingClientRect() : null;
    quizCardGlideFinish?.();

    if (next) {
        window.closeCalendarSurface?.({ immediate: true, force: true });
        const computed = getComputedStyle(card);
        if (computed.display === 'none' || computed.visibility === 'hidden') return false;
        if (isPdfPaneExpanded) togglePdfPaneExpanded(false);

        quizCardExpandRestoreState = {
            layoutMode: getQuizCardLayoutMode(),
            isFloating: card.classList.contains('is-floating'),
            floatingContentScale: card.dataset.floatingContentScale || '',
            styles: {
                position: card.style.position || '',
                left: card.style.left || '',
                top: card.style.top || '',
                right: card.style.right || '',
                bottom: card.style.bottom || '',
                inset: card.style.inset || '',
                width: card.style.width || '',
                height: card.style.height || '',
                margin: card.style.margin || '',
                maxWidth: card.style.maxWidth || '',
                maxHeight: card.style.maxHeight || '',
                zIndex: card.style.zIndex || '',
                overflow: card.style.overflow || '',
                borderRadius: card.style.borderRadius || ''
            }
        };

        card.classList.add('quiz-card-expanded');
        document.body.classList.add('quiz-card-expanded-mode');
        isQuizCardExpanded = true;
        if (options.holdRail) holdRailForQuizCardExpand();
        applyQuizCardContentScale({ forceReset: true });
        syncQuizExpandLockButton();
        if (glideFrom) glideQuizCardBetween(card, glideFrom, card.getBoundingClientRect());
        if (els.popup?.classList.contains('active') && currentPopupBtn) updatePopupPosition();
        return true;
    }

    card.classList.remove('quiz-card-expanded');
    document.body.classList.remove('quiz-card-expanded-mode');

    if (quizCardExpandRestoreState) {
        const prior = quizCardExpandRestoreState.styles || {};
        card.classList.toggle('is-floating', !!quizCardExpandRestoreState.isFloating);
        card.style.position = prior.position || '';
        card.style.left = prior.left || '';
        card.style.top = prior.top || '';
        card.style.right = prior.right || '';
        card.style.bottom = prior.bottom || '';
        card.style.inset = prior.inset || '';
        card.style.width = prior.width || '';
        card.style.height = prior.height || '';
        card.style.margin = prior.margin || '';
        card.style.maxWidth = prior.maxWidth || '';
        card.style.maxHeight = prior.maxHeight || '';
        card.style.zIndex = prior.zIndex || '';
        card.style.overflow = prior.overflow || '';
        card.style.borderRadius = prior.borderRadius || '';
        if (quizCardExpandRestoreState.floatingContentScale) {
            card.dataset.floatingContentScale = quizCardExpandRestoreState.floatingContentScale;
        } else {
            delete card.dataset.floatingContentScale;
        }
    }

    const previousLayoutMode = quizCardExpandRestoreState?.layoutMode;
    quizCardExpandRestoreState = null;
    isQuizCardExpanded = false;
    if (previousLayoutMode && previousLayoutMode !== getQuizCardLayoutMode()) {
        resetQuizCardPosition({ layoutMode: getQuizCardLayoutMode() });
    }
    scheduleQuizCardContentScaleSync();
    syncQuizExpandLockButton();
    syncFloatingQuizLayering();
    const railRestored = releaseRailForQuizCardExpand();
    // Collapses that skip the summary's own button (rail, Escape, leaving) still relabel it.
    if (typeof syncResultsExpandButtonState === 'function') syncResultsExpandButtonState();
    if (glideFrom) {
        // Land on the slot the card will hold once the rail is back, not on the work area mid-transition.
        const workArea = $('work-area');
        const priorTransition = workArea?.style.getPropertyValue('transition') || '';
        const priorPriority = workArea?.style.getPropertyPriority('transition') || '';
        if (workArea && railRestored) workArea.style.setProperty('transition', 'none', 'important');
        const glideTo = card.getBoundingClientRect();
        if (workArea && railRestored) {
            workArea.getBoundingClientRect();
            if (priorTransition) workArea.style.setProperty('transition', priorTransition, priorPriority);
            else workArea.style.removeProperty('transition');
        }
        glideQuizCardBetween(card, glideFrom, glideTo);
    }
    if (els.popup?.classList.contains('active') && currentPopupBtn) updatePopupPosition();
    return true;
}

function setupQuizCardDoubleClickExpand() {
    const card = els?.quizCard || $('quiz-card');
    if (!card || card.dataset.expandDblBound === '1') return;
    // Keep the legacy initialization contract without binding dblclick: text selection must be inert.
    card.dataset.expandDblBound = '1';
}

let quickActionsHideTimer = null;
let quickActionsDockOpen = false;

// Shuffle stays as it is while questions are generating: explanations are written in display
// order, so reordering mid-run would put unexplained questions in front of the student.
function syncShuffleGenerationLock() {
    const locked = typeof isAnyQuizGenerationActive === 'function' && isAnyQuizGenerationActive() === true;
    const title = locked ? 'Shuffle is paused while questions generate' : null;
    [els.shuffleBtn, els.quickActionsMenu?.querySelector('.quiz-quick-action-btn[data-quick-action="shuffle"]')].forEach((btn) => {
        if (!btn) return;
        btn.disabled = locked;
        btn.classList.toggle('is-generation-locked', locked);
        if (locked) {
            btn.setAttribute('aria-disabled', 'true');
            if (btn.dataset.lockPrevTitle === undefined) btn.dataset.lockPrevTitle = btn.getAttribute('title') || '';
            btn.setAttribute('title', title);
        } else if (btn.dataset.lockPrevTitle !== undefined) {
            btn.removeAttribute('aria-disabled');
            if (btn.dataset.lockPrevTitle) btn.setAttribute('title', btn.dataset.lockPrevTitle);
            else btn.removeAttribute('title');
            delete btn.dataset.lockPrevTitle;
        }
    });
    return locked;
}
window.syncShuffleGenerationLock = syncShuffleGenerationLock;

function syncQuickActionsMenuState() {
    syncShuffleGenerationLock();
    if (!els.quickActionsMenu) return;
    const getActionBtn = (action) => els.quickActionsMenu.querySelector(`.quiz-quick-action-btn[data-quick-action="${action}"]`);
    const mixBtn = getActionBtn('mix');
    const hardBtn = getActionBtn('hard');
    const shuffleBtn = getActionBtn('shuffle');

    if (mixBtn) mixBtn.classList.toggle('active', !!els.mixAnswersBtn?.classList.contains('active'));
    if (hardBtn) hardBtn.classList.toggle('active', !!els.hardModeBtn?.classList.contains('active'));
    if (shuffleBtn) shuffleBtn.classList.toggle('active', !!els.shuffleBtn?.classList.contains('active'));
    if (typeof syncQuizRegenerateButtonState === 'function') syncQuizRegenerateButtonState();
    window.syncHighYieldQuizControls?.();
    arrangeQuickActionsMenuGroups(els.quickActionsMenu);
}

function setQuickActionsDockOpen(isOpen, options = {}) {
    const { focusFirst = false } = options;
    if (!els.quickActionsDock || !els.quickActionsTrigger || !els.quickActionsMenu) return;

    clearTimeout(quickActionsHideTimer);
    quickActionsHideTimer = null;
    quickActionsDockOpen = !!isOpen;

    if (quickActionsDockOpen) {
        // An open answer explanation sits over the menu, so Tools closes it first.
        if (typeof closeActiveAnchoredPopup === 'function') closeActiveAnchoredPopup();
        syncQuickActionsMenuState();
        els.quickActionsMenu.removeAttribute('hidden');
        // Measure and place the portaled menu before opacity is raised. This keeps
        // collision correction invisible instead of letting the menu jump after reveal.
        positionQuickActionsDock();
        requestAnimationFrame(() => {
            if (!quickActionsDockOpen || !els.quickActionsDock || !els.quickActionsTrigger) return;
            els.quickActionsDock.classList.add('is-open');
            scheduleQuickActionsDockPosition();
            els.quickActionsTrigger.setAttribute('aria-expanded', 'true');
            // Desktop hides items the prototype drops, so focus the first one actually shown.
            if (focusFirst) {
                [...els.quickActionsMenu.querySelectorAll('.quiz-quick-action-btn')]
                    .find((item) => item.getClientRects().length > 0)?.focus();
            }
        });
        return;
    }

    els.quickActionsDock.classList.remove('is-open');
    scheduleQuickActionsDockPosition();
    els.quickActionsTrigger.setAttribute('aria-expanded', 'false');
    quickActionsHideTimer = setTimeout(() => {
        if (quickActionsDockOpen || !els.quickActionsMenu) return;
        els.quickActionsMenu.setAttribute('hidden', '');
    }, 190);
}

function closeQuickActionsDock() {
    if (!els.quickActionsDock) return;
    setQuickActionsDockOpen(false);
}

const QUIZ_CARD_REFERENCE_WIDTH = 800;
const QUIZ_CARD_MIN_CONTENT_SCALE = 0.48;
const QUIZ_CARD_MAX_AUTO_CONTENT_SCALE = 1.14;
const QUIZ_CARD_MAX_CONTENT_SCALE = 1.32;
const QUIZ_CARD_CONTENT_SCALE_STEP = 0.06;
const QUIZ_CARD_SINGLE_LAYOUT_DEFAULT_SCALE = 0.66 - (QUIZ_CARD_CONTENT_SCALE_STEP * 3); // = 0.48 (one ctrl-down step below the previous 0.54 default)
const QUIZ_CARD_PHONE_CONTENT_SCALE = 0.66;
const QUIZ_CARD_SINGLE_LAYOUT_BASELINE_SCALE_DELTA = QUIZ_CARD_CONTENT_SCALE_STEP * 2;
const QUIZ_CARD_DUO_LAYOUT_BASELINE_SCALE_DELTA = -(QUIZ_CARD_CONTENT_SCALE_STEP * 3);
const QUIZ_CARD_TRIO_LAYOUT_BASELINE_SCALE_DELTA = QUIZ_CARD_CONTENT_SCALE_STEP * 4; // two ctrl-down steps below the previous trio default (was STEP * 6)
const QUIZ_CARD_MIN_WIDTH = Math.max(360, Math.round(QUIZ_CARD_REFERENCE_WIDTH * QUIZ_CARD_MIN_CONTENT_SCALE));
const QUIZ_CARD_MIN_HEIGHT = 420;
const QUIZ_CARD_GEOMETRY_STORAGE_KEY = 'quiz_card_geometry_v2';

function isPhoneQuizCardGeometryLocked() {
    return document.documentElement.classList.contains('phone-device');
}
const QUIZ_CARD_CONTENT_SCALE_STORAGE_KEY = 'quiz_card_content_scale_v3';
const QUIZ_CARD_CUSTOM_SIZE_CLASS = 'quiz-card-custom-sized';
const QUIZ_CARD_CUSTOM_WIDTH_CLASS = 'quiz-card-custom-width';
const QUIZ_CARD_CUSTOM_HEIGHT_CLASS = 'quiz-card-custom-height';
const QUIZ_CARD_SHIFT_DRAG_FLOATING_ENABLED = true;
const QUIZ_CARD_DEFAULT_GEOMETRY = Object.freeze({
    // 20% under the previous 1240 x 807, which read as oversized.
    single: Object.freeze({ width: 992, height: 646 }),
    duo: Object.freeze({ width: 0, height: 700 }),
    trio: Object.freeze({ width: 612, height: 780 })
});
let quizCardContentScaleFrame = 0;
let quizCardPositionResetFrame = 0;
let quizCardManualContentScaleDelta = 0;
let quizCardContentScaleLayoutMode = '';

function getQuizCardLayoutMode() {
    if (document.body?.classList?.contains('zen-active')) return 'single';
    const body = document.body;
    if (body?.classList?.contains('quiz-side-surface-in-pane')
        || body?.classList?.contains('ask-ai-docked-open')
        || body?.classList?.contains('notes-docked-open')) return 'duo';
    const workArea = els?.workArea || $('work-area');
    if (workArea?.classList?.contains('pane-layout-target-single')) return 'single';
    if (workArea?.classList?.contains('pane-layout-target-duo')) return 'duo';
    if (workArea?.classList?.contains('pane-layout-target-trio')) return 'trio';
    if (workArea?.classList?.contains('trio-view') || workArea?.classList?.contains('pdf-tutor-quiz-trio')) return 'trio';
    if (workArea?.classList?.contains('split-view')
        || workArea?.classList?.contains('split-view-ai')
        || workArea?.classList?.contains('pdf-tutor-quiz-duo')) return 'duo';
    return 'single';
}

function isIpadDuoQuizCardLayout(layoutMode = getQuizCardLayoutMode()) {
    const root = document.documentElement;
    return layoutMode === 'duo'
        && root.classList.contains('ipad-like-device')
        && !root.classList.contains('phone-device');
}

function getIpadDuoIntrinsicQuizCardHeight(maxH, minH) {
    const safeMax = Math.max(minH, Number(maxH) || minH);
    // Keep the quiz card content-led on iPad. The pane remains the scroll
    // owner, while this cap prevents a portrait/landscape pane from turning
    // the card into a full-height block with a large empty lower band.
    return Math.round(Math.max(minH, Math.min(safeMax, Math.min(640, safeMax * 0.86))));
}

function applyIpadDuoQuizCardIntrinsicMinHeight(card) {
    const pane = $('quiz-pane');
    const paneRect = pane?.getBoundingClientRect?.();
    const cardRect = card?.getBoundingClientRect?.();
    if (!card || !pane || !paneRect || !cardRect || !(pane.clientHeight > 0)) return;
    // An upright iPad's pane is tall: this floor stretched the card to ~800px around ~400px of
    // quiz, a long empty band. There the card hugs its content (guarded by the "@left-rail iPad
    // portrait duo" spec in live-left-rail-preview.spec.js).
    if (window.innerHeight > window.innerWidth) {
        card.style.minHeight = '';
        return;
    }
    const topOffset = Math.max(0, cardRect.top - paneRect.top);
    const available = pane.clientHeight - topOffset - 180;
    const minHeight = Math.round(Math.max(300, Math.min(800, available)));
    card.style.minHeight = `${minHeight}px`;
}

function readQuizCardGeometryStore() {
    try {
        const parsed = JSON.parse(localStorage.getItem(QUIZ_CARD_GEOMETRY_STORAGE_KEY) || '{}');
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (_err) {
        return {};
    }
}

function writeQuizCardGeometryStore(store) {
    try {
        localStorage.setItem(QUIZ_CARD_GEOMETRY_STORAGE_KEY, JSON.stringify(store || {}));
    } catch (_err) {
        // Ignore storage failures.
    }
}

function clearQuizCardGeometryForLayout(layoutMode) {
    if (!layoutMode) return;
    const store = readQuizCardGeometryStore();
    if (!Object.prototype.hasOwnProperty.call(store, layoutMode)) return;
    delete store[layoutMode];
    writeQuizCardGeometryStore(store);
}

function setQuizCardManualGeometryState(isManual = false) {
    const card = els?.quizCard || $('quiz-card');
    if (!card) return;
    if (isManual) {
        card.dataset.quizManualGeometry = '1';
    } else {
        delete card.dataset.quizManualGeometry;
    }
}

function getAnchoredQuizCardMaxHeight(layoutMode = getQuizCardLayoutMode()) {
    const pane = $('quiz-pane');
    const card = els?.quizCard || $('quiz-card');
    const paneRect = pane?.getBoundingClientRect?.() || null;
    const paneHeight = Math.max(
        0,
        pane?.clientHeight || Number(paneRect?.height) || 0
    );
    if (!paneHeight) return 0;

    let visibleTopOffset = 0;
    if (card && paneRect) {
        const cardRect = card.getBoundingClientRect();
        if (Number.isFinite(cardRect?.top) && Number.isFinite(paneRect.top)) {
            visibleTopOffset = Math.max(0, Math.round(cardRect.top - paneRect.top));
        }
    } else if (card && pane) {
        visibleTopOffset = Math.max(
            0,
            Math.round((card.offsetTop || 0) - (pane.scrollTop || 0))
        );
    }

    const bottomClearance = layoutMode === 'single' ? 12 : 10;
    return Math.max(220, Math.round(paneHeight - visibleTopOffset - bottomClearance));
}

function readQuizCardContentScaleStore() {
    try {
        const parsed = JSON.parse(localStorage.getItem(QUIZ_CARD_CONTENT_SCALE_STORAGE_KEY) || '{}');
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (_err) {
        return {};
    }
}

function writeQuizCardContentScaleStore(store) {
    try {
        localStorage.setItem(QUIZ_CARD_CONTENT_SCALE_STORAGE_KEY, JSON.stringify(store || {}));
    } catch (_err) {
        // Ignore storage failures.
    }
}

function clearQuizCardContentScaleDeltaForLayout(layoutMode) {
    if (!layoutMode) return;
    const store = readQuizCardContentScaleStore();
    if (Object.prototype.hasOwnProperty.call(store, layoutMode)) {
        delete store[layoutMode];
        writeQuizCardContentScaleStore(store);
    }
    if (quizCardContentScaleLayoutMode === layoutMode) {
        quizCardManualContentScaleDelta = 0;
    }
}

function restoreQuizCardContentScaleDeltaForLayout(layoutMode = getQuizCardLayoutMode()) {
    const store = readQuizCardContentScaleStore();
    const saved = Number(store?.[layoutMode]);
    const defaultDelta = layoutMode === 'single'
        ? QUIZ_CARD_SINGLE_LAYOUT_BASELINE_SCALE_DELTA
        : 0;
    quizCardManualContentScaleDelta = Number.isFinite(saved) ? saved : defaultDelta;
    quizCardContentScaleLayoutMode = layoutMode;
}

function ensureQuizCardContentScaleDeltaForCurrentLayout() {
    const layoutMode = getQuizCardLayoutMode();
    if (quizCardContentScaleLayoutMode === layoutMode) return;
    restoreQuizCardContentScaleDeltaForLayout(layoutMode);
}

function saveQuizCardContentScaleDeltaForCurrentLayout() {
    const layoutMode = getQuizCardLayoutMode();
    const store = readQuizCardContentScaleStore();
    store[layoutMode] = Number(quizCardManualContentScaleDelta.toFixed(4));
    writeQuizCardContentScaleStore(store);
    quizCardContentScaleLayoutMode = layoutMode;
}

function getQuizCardSizeBounds(layoutMode = getQuizCardLayoutMode()) {
    const pane = $('quiz-pane');
    const paneRect = pane?.getBoundingClientRect?.() || null;
    const paneWidth = Number(paneRect?.width) || 0;
    const paneHeight = Number(paneRect?.height) || 0;
    const fallbackWidth = Math.max(360, window.innerWidth - 24);
    const fallbackHeight = Math.max(320, window.innerHeight - 24);
    const usableWidth = paneWidth > 120 ? paneWidth : fallbackWidth;
    const usableHeight = paneHeight > 120 ? paneHeight : fallbackHeight;
    const maxWidthCap = layoutMode === 'single' ? 1656 : 900;
    const maxW = Math.max(320, Math.min(Math.round(usableWidth - 24), maxWidthCap));
    const anchoredMaxHeight = getAnchoredQuizCardMaxHeight(layoutMode);
    const maxH = Math.max(
        220,
        Math.min(
            Math.round(usableHeight - 24),
            anchoredMaxHeight > 0 ? anchoredMaxHeight : Number.POSITIVE_INFINITY
        )
    );
    const minW = Math.min(QUIZ_CARD_MIN_WIDTH, maxW);
    const minH = Math.min(QUIZ_CARD_MIN_HEIGHT, maxH);
    return { minW, maxW, minH, maxH };
}

function getDefaultQuizCardGeometry(layoutMode = getQuizCardLayoutMode()) {
    const { minW, maxW, minH, maxH } = getQuizCardSizeBounds(layoutMode);
    if (layoutMode === 'duo') {
        return {
            width: Math.round(Math.max(minW, Math.min(maxW, Math.round(maxW * 0.94)))),
            height: isIpadDuoQuizCardLayout(layoutMode)
                ? getIpadDuoIntrinsicQuizCardHeight(maxH, minH)
                : Math.round(Math.max(minH, Math.min(maxH, QUIZ_CARD_DEFAULT_GEOMETRY.duo.height)))
        };
    }

    if (layoutMode === 'trio') {
        return {
            width: Math.round(Math.max(minW, Math.min(maxW, Math.round(maxW * 0.96)))),
            height: Math.round(Math.max(minH, Math.min(maxH, maxH)))
        };
    }

    const preset = QUIZ_CARD_DEFAULT_GEOMETRY[layoutMode];
    if (!preset) return null;

    return {
        width: Math.round(Math.max(minW, Math.min(maxW, preset.width))),
        height: Math.round(Math.max(minH, Math.min(maxH, preset.height)))
    };
}

function syncQuizCardCustomGeometryState() {
    const card = els?.quizCard || $('quiz-card');
    if (!card) return false;

    const hasCustomWidth = !!String(card.style.width || '').trim();
    const hasCustomHeight = !!String(card.style.height || '').trim();
    const hasCustomGeometry = hasCustomWidth || hasCustomHeight;
    card.classList.toggle(QUIZ_CARD_CUSTOM_SIZE_CLASS, hasCustomGeometry);
    card.classList.toggle(QUIZ_CARD_CUSTOM_WIDTH_CLASS, hasCustomWidth);
    card.classList.toggle(QUIZ_CARD_CUSTOM_HEIGHT_CLASS, hasCustomHeight);
    return hasCustomGeometry;
}

function saveQuizCardGeometryForCurrentLayout(layoutMode = getQuizCardLayoutMode()) {
    const card = els?.quizCard || $('quiz-card');
    if (!card || isQuizCardExpanded || getComputedStyle(card).display === 'none') return;
    if (layoutMode !== 'single') return;
    if (document.body.classList.contains('ask-ai-docked-open')
        || document.body.classList.contains('notes-docked-open')
        || document.body.classList.contains('quiz-side-surface-switching')) return;
    const isPhoneLayout = document.documentElement.classList.contains('phone-device')
        || (typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 700px)').matches);
    if (isPhoneLayout || isIpadDuoQuizCardLayout(layoutMode)) return;

    const rect = card.getBoundingClientRect();
    if (!Number.isFinite(rect.width) || rect.width < 40 || !Number.isFinite(rect.height) || rect.height < 40) return;

    const { minW, maxW, minH, maxH } = getQuizCardSizeBounds(layoutMode);
    const store = readQuizCardGeometryStore();
    store[layoutMode] = {
        width: Math.round(Math.max(minW, Math.min(maxW, rect.width))),
        height: Math.round(Math.max(minH, Math.min(maxH, rect.height))),
        manual: true
    };
    writeQuizCardGeometryStore(store);
    setQuizCardManualGeometryState(true);
}

function restoreQuizCardGeometryForCurrentLayout(layoutMode = getQuizCardLayoutMode()) {
    const card = els?.quizCard || $('quiz-card');
    if (!card || isQuizCardExpanded) return false;
    const isPhoneLayout = document.documentElement.classList.contains('phone-device')
        || (typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 700px)').matches);
    if (isPhoneLayout) {
        card.style.width = '';
        card.style.height = '';
        card.style.minHeight = '';
        syncQuizCardCustomGeometryState();
        setQuizCardManualGeometryState(false);
        return false;
    }

    if (isIpadDuoQuizCardLayout(layoutMode)) {
        const preset = getDefaultQuizCardGeometry(layoutMode);
        if (!preset) return false;
        const { minW, maxW } = getQuizCardSizeBounds(layoutMode);
        card.style.width = `${Math.round(Math.max(minW, Math.min(maxW, preset.width)))}px`;
        card.style.height = '';
        applyIpadDuoQuizCardIntrinsicMinHeight(card);
        syncQuizCardCustomGeometryState();
        setQuizCardManualGeometryState(false);
        return true;
    }

    const store = readQuizCardGeometryStore();
    // Multi-pane geometry is pane-owned. Ignore legacy manual duo/trio sizes without
    // deleting the learner's single-view preference.
    const saved = layoutMode === 'single' ? store[layoutMode] : null;
    const hasManualGeometry = layoutMode === 'single' && saved?.manual === true;
    // Only a size the learner chose by resizing outlives a change to the default.
    let width = hasManualGeometry ? Number(saved?.width) : Number.NaN;
    let height = hasManualGeometry ? Number(saved?.height) : Number.NaN;

    if (!Number.isFinite(width) || !Number.isFinite(height)) {
        const preset = getDefaultQuizCardGeometry(layoutMode);
        if (!preset) {
            syncQuizCardCustomGeometryState();
            setQuizCardManualGeometryState(false);
            return false;
        }
        width = preset.width;
        height = preset.height;
    }

    const { minW, maxW, minH, maxH } = getQuizCardSizeBounds(layoutMode);
    card.style.width = `${Math.round(Math.max(minW, Math.min(maxW, width)))}px`;
    card.style.height = `${Math.round(Math.max(minH, Math.min(maxH, height)))}px`;
    card.style.minHeight = '';
    syncQuizCardCustomGeometryState();
    setQuizCardManualGeometryState(hasManualGeometry);
    return true;
}

function resetQuizCardToLayoutDefault(layoutMode = getQuizCardLayoutMode()) {
    const card = els?.quizCard || $('quiz-card');
    if (!card || isQuizCardExpanded) return false;
    const isPhoneLayout = document.documentElement.classList.contains('phone-device')
        || (typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 700px)').matches);
    if (isPhoneLayout) {
        card.style.width = '';
        card.style.height = '';
        card.style.minHeight = '';
        syncQuizCardCustomGeometryState();
        setQuizCardManualGeometryState(false);
        return false;
    }

    if (isIpadDuoQuizCardLayout(layoutMode)) {
        clearQuizCardGeometryForLayout(layoutMode);
        restoreQuizCardContentScaleDeltaForLayout(layoutMode);
        const preset = getDefaultQuizCardGeometry(layoutMode);
        if (!preset) return false;
        const { minW, maxW } = getQuizCardSizeBounds(layoutMode);
        card.style.width = `${Math.round(Math.max(minW, Math.min(maxW, preset.width)))}px`;
        card.style.height = '';
        applyIpadDuoQuizCardIntrinsicMinHeight(card);
        syncQuizCardCustomGeometryState();
        setQuizCardManualGeometryState(false);
        scheduleQuizCardContentScaleSync();
        scheduleQuickActionsDockPosition();
        return true;
    }

    clearQuizCardGeometryForLayout(layoutMode);
    restoreQuizCardContentScaleDeltaForLayout(layoutMode);

    const preset = getDefaultQuizCardGeometry(layoutMode);
    if (!preset) return false;

    const { minW, maxW, minH, maxH } = getQuizCardSizeBounds(layoutMode);
    card.style.width = `${Math.round(Math.max(minW, Math.min(maxW, preset.width)))}px`;
    card.style.height = `${Math.round(Math.max(minH, Math.min(maxH, preset.height)))}px`;
    card.style.minHeight = '';
    syncQuizCardCustomGeometryState();
    setQuizCardManualGeometryState(false);
    scheduleQuizCardHeightNormalization();
    scheduleQuizCardContentScaleSync();
    scheduleQuickActionsDockPosition();
    return true;
}

function normalizeAnchoredQuizCardHeight() {
    const card = els?.quizCard || $('quiz-card');
    const navRow = $('nav-row');
    const layoutMode = getQuizCardLayoutMode();
    const workArea = els?.workArea || $('work-area');
    if (workArea?.classList.contains('pane-open-transitioning')
        || workArea?.classList.contains('pane-close-transitioning')) {
        setTimeout(scheduleQuizCardHeightNormalization, 180);
        return false;
    }
    if (document.body?.classList?.contains('zen-active')) return false;
    if (isIpadDuoQuizCardLayout(layoutMode)
        && card
        && !card.dataset.quizManualGeometry
        && !isQuizCardManualResizeActive
        && !isQuizCardResultsVisible()) {
        if (card.style.height) {
            card.style.height = '';
            syncQuizCardCustomGeometryState();
        }
        applyIpadDuoQuizCardIntrinsicMinHeight(card);
        return false;
    }
    const shouldPreserveManualHeight = card?.dataset?.quizManualGeometry === '1';
    // Docked Ask changes the card width without changing its quiz layout mode. Its
    // automatically restored single-layout height must therefore be allowed to
    // follow the newly wrapped content; explicit user geometry remains protected.
    const shouldPreserveRestoredHeight = !!String(card?.style?.height || '').trim()
        && !document.body?.classList?.contains('ask-ai-docked-open');
    if (!card || !navRow || isQuizCardExpanded || card.classList.contains('is-floating') || isQuizCardManualResizeActive || shouldPreserveManualHeight || shouldPreserveRestoredHeight || isQuizCardResultsVisible()) return false;

    const cardRect = card.getBoundingClientRect();
    const navRect = navRow.getBoundingClientRect();
    if (!Number.isFinite(cardRect.height) || !Number.isFinite(navRect.bottom) || cardRect.height <= 0) return false;

    const cardStyles = getComputedStyle(card);
    const paddingBottom = parseFloat(cardStyles.paddingBottom) || 0;
    const { minH, maxH } = getQuizCardSizeBounds(layoutMode);
    const cssMinHeight = Math.max(0, parseFloat(cardStyles.minHeight) || 0);
    const hasManualSingleLayoutScale = layoutMode === 'single' && Math.abs(quizCardManualContentScaleDelta) > 0.001;
    const minCardHeight = hasManualSingleLayoutScale
        ? cssMinHeight
        : Math.max(cssMinHeight, minH);
    const targetHeight = Math.round(Math.max(minCardHeight, (navRect.bottom - cardRect.top) + paddingBottom + 12));
    const clampedHeight = Math.round(Math.max(minCardHeight, Math.min(maxH, targetHeight)));
    if (Math.abs(cardRect.height - clampedHeight) <= 12) return false;

    if (document.body?.classList?.contains('ask-ai-docked-open')
        && !('quizDockedAskRestoreHeight' in card.dataset)) {
        card.dataset.quizDockedAskRestoreHeight = card.style.height || '';
    }
    card.style.height = `${clampedHeight}px`;
    syncQuizCardCustomGeometryState();
    scheduleQuizCardContentScaleSync();
    scheduleQuickActionsDockPosition();
    return true;
}

function scheduleQuizCardHeightNormalization() {
    if (quizCardHeightNormalizeRaf) cancelAnimationFrame(quizCardHeightNormalizeRaf);
    quizCardHeightNormalizeRaf = requestAnimationFrame(() => {
        quizCardHeightNormalizeRaf = 0;
        normalizeAnchoredQuizCardHeight();
    });
}

// The quiz flow shows and hides these views with inline display, so read that first; a computed
// read here forced a style flush in the middle of every pane open and close.
function isQuizCardViewDisplayed(node) {
    if (!node) return false;
    const inline = node.style?.display;
    return inline ? inline !== 'none' : getComputedStyle(node).display !== 'none';
}

function isQuizCardResultsVisible() {
    return isQuizCardViewDisplayed(els?.resultsView || $('results-view'));
}

function getQuizCardBaselineContentScaleDelta(card, layoutMode = getQuizCardLayoutMode()) {
    const hasAnchoredGeometry = card
        && !card.classList.contains('is-floating');
    if (!hasAnchoredGeometry) return 0;
    if (layoutMode === 'single') return QUIZ_CARD_SINGLE_LAYOUT_BASELINE_SCALE_DELTA;
    if (layoutMode === 'duo') return QUIZ_CARD_DUO_LAYOUT_BASELINE_SCALE_DELTA;
    if (layoutMode === 'trio') return QUIZ_CARD_TRIO_LAYOUT_BASELINE_SCALE_DELTA;
    return 0;
}

function canUseQuizCardLayoutZoom(card, layoutMode = getQuizCardLayoutMode()) {
    if (!card || card.classList.contains('is-floating') || isQuizCardExpanded) return false;
    if (layoutMode !== 'single' && layoutMode !== 'duo' && layoutMode !== 'trio') return false;
    return typeof CSS !== 'undefined'
        && typeof CSS.supports === 'function'
        && CSS.supports('zoom', '1');
}

function applyQuizCardContentScale({ forceReset = false } = {}) {
    const card = els?.quizCard || $('quiz-card');
    const content = els?.quizContent || $('quiz-content-wrapper');
    const shell = els?.quizScaleShell || $('quiz-scale-shell');
    if (!card || !content || !shell) return 1;
    ensureQuizCardContentScaleDeltaForCurrentLayout();

    const resetScale = () => {
        card.style.setProperty('--quiz-content-scale', '1');
        content.classList.remove('quiz-content-scaled');
        shell.classList.remove('quiz-scale-shell-layout-zoom');
        shell.style.minHeight = '';
        shell.style.marginBottom = '';
        content.style.overflow = '';
        content.style.overflowX = '';
        content.style.overflowY = '';
        scheduleQuickActionsDockPosition();
        return 1;
    };

    const applyFrozenScale = (rawScale) => {
        const nextScale = Number(rawScale);
        if (!Number.isFinite(nextScale) || nextScale <= 0) return resetScale();
        card.style.setProperty('--quiz-content-scale', nextScale.toFixed(4));
        content.classList.toggle('quiz-content-scaled', Math.abs(nextScale - 1) > 0.001);
        const canLayoutZoom = typeof CSS !== 'undefined'
            && typeof CSS.supports === 'function'
            && CSS.supports('zoom', '1');
        shell.classList.toggle(
            'quiz-scale-shell-layout-zoom',
            canLayoutZoom && Math.abs(nextScale - 1) > 0.001
        );
        shell.style.minHeight = '';
        if (canLayoutZoom) {
            shell.style.marginBottom = '';
        } else {
            const naturalHeight = shell.offsetHeight;
            const compensation = Math.max(0, Math.round(naturalHeight * (1 - nextScale)));
            const currentMargin = parseFloat(shell.style.marginBottom || '0') || 0;
            if (Math.abs(currentMargin + compensation) > 1) {
                shell.style.marginBottom = compensation ? `-${compensation}px` : '';
            }
        }
        content.style.overflow = '';
        content.style.overflowX = '';
        content.style.overflowY = '';
        scheduleQuickActionsDockPosition();
        return nextScale;
    };

    if (typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 700px)').matches) {
        const phoneScale = Math.min(
            1.0,
            Math.max(0.66, QUIZ_CARD_PHONE_CONTENT_SCALE + quizCardManualContentScaleDelta)
        );
        quizCardManualContentScaleDelta = phoneScale - QUIZ_CARD_PHONE_CONTENT_SCALE;
        return applyFrozenScale(phoneScale);
    }

    const resultsVisible = isQuizCardResultsVisible();
    const contentVisible = isQuizCardViewDisplayed(content);
    if (forceReset || resultsVisible || !contentVisible || isQuizCardExpanded) {
        return resetScale();
    }
    if (card.classList.contains('is-floating')) {
        const frozenScale = Number(card.dataset.floatingContentScale || card.style.getPropertyValue('--quiz-content-scale'));
        return applyFrozenScale(frozenScale);
    }

    const hasDetachedGeometry = card.classList.contains('is-floating')
        || !!String(card.style.width || '').trim()
        || !!String(card.style.height || '').trim();
    const layoutMode = getQuizCardLayoutMode();
    const shouldUseFixedSingleLayoutScale = layoutMode === 'single'
        && !card.classList.contains('is-floating');
    const shouldUseLayoutZoom = !card.classList.contains('is-floating')
        && canUseQuizCardLayoutZoom(card, layoutMode);
    const shouldScaleForLayout = layoutMode !== 'single';
    const baselineScaleDelta = getQuizCardBaselineContentScaleDelta(card, layoutMode);
    const hasManualScaleOverride = Math.abs(quizCardManualContentScaleDelta) > 0.001;
    if (!hasDetachedGeometry && !shouldScaleForLayout && Math.abs(baselineScaleDelta) <= 0.001 && !hasManualScaleOverride) {
        return resetScale();
    }

    const cardStyles = getComputedStyle(card);
    const horizontalPadding = (parseFloat(cardStyles.paddingLeft) || 0) + (parseFloat(cardStyles.paddingRight) || 0);
    const baseContentWidth = Math.max(1, QUIZ_CARD_REFERENCE_WIDTH - horizontalPadding);
    const workArea = els?.workArea || $('work-area');
    const paneOpenTargetCardWidth = workArea?.classList.contains('pane-open-transitioning')
        ? Number.parseFloat(card.style.getPropertyValue('--pane-layout-target-card-width'))
        : Number.NaN;
    // While a pane opens, clientWidth is the card's animated in-between width.
    // Use the already-resolved destination width so the internal content scale
    // stays fixed from the first frame through transition cleanup. It must match
    // the clientWidth the settle pass reads (borders out, rounded like clientWidth),
    // or the scale steps once more after landing and the question re-wraps.
    const horizontalBorder = (parseFloat(cardStyles.borderLeftWidth) || 0) + (parseFloat(cardStyles.borderRightWidth) || 0);
    const availableWidth = Math.max(
        1,
        Number.isFinite(paneOpenTargetCardWidth) && paneOpenTargetCardWidth > horizontalPadding + horizontalBorder
            ? Math.round(paneOpenTargetCardWidth - horizontalPadding - horizontalBorder)
            : content.clientWidth
    );

    let baseScale = availableWidth / baseContentWidth;
    if (!Number.isFinite(baseScale) || baseScale <= 0) baseScale = 1;
    baseScale = Math.max(QUIZ_CARD_MIN_CONTENT_SCALE, Math.min(QUIZ_CARD_MAX_AUTO_CONTENT_SCALE, baseScale));

    let nextScale = shouldUseFixedSingleLayoutScale
        ? Math.max(
            QUIZ_CARD_MIN_CONTENT_SCALE,
            Math.min(QUIZ_CARD_MAX_CONTENT_SCALE, QUIZ_CARD_SINGLE_LAYOUT_DEFAULT_SCALE + quizCardManualContentScaleDelta)
        )
        : Math.max(
            QUIZ_CARD_MIN_CONTENT_SCALE,
            Math.min(QUIZ_CARD_MAX_CONTENT_SCALE, baseScale + baselineScaleDelta + quizCardManualContentScaleDelta)
        );
    quizCardManualContentScaleDelta = shouldUseFixedSingleLayoutScale
        ? (nextScale - QUIZ_CARD_SINGLE_LAYOUT_DEFAULT_SCALE)
        : (nextScale - baseScale - baselineScaleDelta);
    card.style.setProperty('--quiz-content-scale', nextScale.toFixed(4));
    content.classList.toggle('quiz-content-scaled', Math.abs(nextScale - 1) > 0.001);
    shell.classList.toggle('quiz-scale-shell-layout-zoom', shouldUseLayoutZoom && Math.abs(nextScale - 1) > 0.001);
    content.style.overflowX = 'hidden';
    content.style.overflowY = 'auto';

    const shouldCompensateSingleLayoutShellHeight = shouldUseFixedSingleLayoutScale
        && !shouldUseLayoutZoom
        && Math.abs(quizCardManualContentScaleDelta) <= 0.001;
    if (shouldCompensateSingleLayoutShellHeight && content.clientHeight > 0 && nextScale > 0) {
        // The scaled shell keeps its unscaled layout height; compensate so the
        // visual bottom still lands at the wrapper bottom instead of leaving a
        // dead zone beneath the nav row.
        shell.style.minHeight = `${Math.ceil(content.clientHeight / nextScale)}px`;
    } else {
        shell.style.minHeight = '';
    }

    scheduleQuickActionsDockPosition();
    return nextScale;
}

function nudgeQuizCardContentScale(direction = 1) {
    const card = els?.quizCard || $('quiz-card');
    const content = els?.quizContent || $('quiz-content-wrapper');
    if (!card || !Number.isFinite(direction) || direction === 0) return false;
    ensureQuizCardContentScaleDeltaForCurrentLayout();
    const isPhoneViewport = typeof window.matchMedia === 'function'
        && window.matchMedia('(max-width: 700px)').matches;
    const layoutMode = getQuizCardLayoutMode();
    const shouldNormalizeAnchoredHeight = layoutMode === 'single'
        && !card.classList.contains('is-floating')
        && !isQuizCardExpanded;

    const computed = getComputedStyle(card);
    if (computed.display === 'none' || computed.visibility === 'hidden') return false;

    const currentScale = parseFloat(computed.getPropertyValue('--quiz-content-scale')) || 1;
    const scrollAnchor = content
        ? (content.scrollTop + (content.clientHeight / 2))
        : 0;
    const restoreScrollAnchor = (nextScale) => {
        if (!content || !Number.isFinite(currentScale) || currentScale <= 0 || !Number.isFinite(nextScale)) return;
        requestAnimationFrame(() => {
            const nextMaxScrollTop = Math.max(0, content.scrollHeight - content.clientHeight);
            if (nextMaxScrollTop <= 0) {
                content.scrollTop = 0;
                return;
            }
            const scaledAnchor = scrollAnchor * (nextScale / currentScale);
            const nextScrollTop = clampNum(
                Math.round(scaledAnchor - (content.clientHeight / 2)),
                0,
                nextMaxScrollTop
            );
            content.scrollTop = nextScrollTop;
        });
    };

    if (card.classList.contains('is-floating') && !isPhoneViewport) {
        const nextFloatingScale = Math.max(
            QUIZ_CARD_MIN_CONTENT_SCALE,
            Math.min(
                QUIZ_CARD_MAX_CONTENT_SCALE,
                currentScale + (direction > 0 ? QUIZ_CARD_CONTENT_SCALE_STEP : -QUIZ_CARD_CONTENT_SCALE_STEP)
            )
        );
        card.dataset.floatingContentScale = nextFloatingScale.toFixed(4);
        const nextScale = applyQuizCardContentScale();
        restoreScrollAnchor(nextScale);
        return true;
    }

    quizCardManualContentScaleDelta += direction > 0
        ? QUIZ_CARD_CONTENT_SCALE_STEP
        : -QUIZ_CARD_CONTENT_SCALE_STEP;
    const nextScale = applyQuizCardContentScale();
    restoreScrollAnchor(nextScale);
    if (shouldNormalizeAnchoredHeight) {
        requestAnimationFrame(() => {
            scheduleQuizCardHeightNormalization();
        });
    }
    saveQuizCardContentScaleDeltaForCurrentLayout();
    return true;
}

function scheduleQuizCardContentScaleSync(options = {}) {
    if (isQuizPaneLayoutTransitioning()
        && !document.documentElement.classList.contains('phone-device')) {
        if (options?.forceReset) quizCardContentScalePendingForceReset = true;
        window.whenPaneLayoutSettled?.(runQuizCardLayoutSettlePass);
        return;
    }
    if (quizCardContentScaleFrame) cancelAnimationFrame(quizCardContentScaleFrame);
    quizCardContentScaleFrame = requestAnimationFrame(() => {
        quizCardContentScaleFrame = 0;
        applyQuizCardContentScale(options);
    });
}

window.playQuizCardWelcomeEntry = function () {
    const card = els?.quizCard || $('quiz-card');
    if (!card || getComputedStyle(card).display === 'none') return false;

    clearTimeout(card._welcomeEntryTimer);
    card.classList.remove('quiz-card-welcome-entering');
    void card.offsetWidth;

    card.classList.add('quiz-card-welcome-entering');

    const finish = (event) => {
        if (event && (event.target !== card || event.animationName !== 'quiz-card-welcome-enter')) return;
        card.classList.remove('quiz-card-welcome-entering');
        card.removeEventListener('animationend', finish);
        clearTimeout(card._welcomeEntryTimer);
        card._welcomeEntryTimer = 0;
        scheduleQuickActionsDockPosition();
    };
    card.addEventListener('animationend', finish);
    card._welcomeEntryTimer = setTimeout(() => finish(), 760);
    return true;
};
function setupResize() {
    const card = els?.quizCard || $('quiz-card');
    const handle = $('resize-handle');
    if (!card || card.dataset.resizeBound === '1') return;
    card.dataset.resizeBound = '1';
    if (handle) handle.dataset.resizeBound = '1';

    const edgeHitbox = 16;
    const resizeIgnoreSelector = [
        'button',
        'select',
        'input',
        'textarea',
        'a',
        '.choice',
        '#resize-handle',
        '.quiz-toolbar-controls',
        '.quiz-quick-actions-dock',
        '.auto-options-dropdown',
        '.refresh-options-dropdown',
        '[contenteditable="true"]'
    ].join(', ');

    let isResizing = false;
    let resizeEdges = null;
    let startRect = null;
    let resizeStartedFloating = false;
    const isTutorQuizGeometryLocked = () => document.body.classList.contains('pdf-tutor-quiz-mode');
    const canDirectResize = () => (
        !isQuizCardExpanded
        && !isTutorQuizGeometryLocked()
        && getQuizCardLayoutMode() === 'single'
    );

    function persistActiveResizeGeometry() {
        if (!canDirectResize()) return;
        syncQuizCardCustomGeometryState();
        saveQuizCardGeometryForCurrentLayout('single');
    }

    function hasResizeEdge(edges) {
        return !!(edges && (edges.top || edges.right || edges.bottom || edges.left));
    }

    function getResizeCursor(edges) {
        if (!hasResizeEdge(edges)) return '';
        if ((edges.top && edges.left) || (edges.bottom && edges.right)) return 'nwse-resize';
        if ((edges.top && edges.right) || (edges.bottom && edges.left)) return 'nesw-resize';
        if (edges.left || edges.right) return 'ew-resize';
        return 'ns-resize';
    }

    function getResizeEdgesFromEvent(e) {
        if (!canDirectResize()) return null;
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        if (x < 0 || y < 0 || x > rect.width || y > rect.height) return null;

        const edges = {
            top: y <= edgeHitbox,
            right: rect.width - x <= edgeHitbox,
            bottom: rect.height - y <= edgeHitbox,
            left: x <= edgeHitbox
        };
        return hasResizeEdge(edges) ? edges : null;
    }

    function clearResizeInteraction({ restoreLayout = false, persist = true } = {}) {
        if (!isResizing) return false;
        isResizing = false;
        isQuizCardManualResizeActive = false;
        card.classList.remove('is-resizing');
        resizeEdges = null;
        startRect = null;
        document.body.style.cursor = '';
        card.style.cursor = '';
        document.querySelectorAll('iframe').forEach((frame) => { frame.style.pointerEvents = ''; });

        if (restoreLayout) {
            card.classList.remove('is-floating');
            delete card.dataset.floatingContentScale;
            card.style.position = '';
            card.style.left = '';
            card.style.top = '';
            card.style.margin = '';
            card.style.zIndex = '';
            card.style.maxHeight = '';
            card.style.overflow = '';
            restoreQuizCardGeometryForCurrentLayout(getQuizCardLayoutMode());
        } else if (!resizeStartedFloating) {
            card.classList.remove('is-floating');
            card.style.position = '';
            card.style.left = '';
            card.style.top = '';
            const workArea = els?.workArea || $('work-area');
            const hasMultiPaneLayout = !!(
                workArea
                && (workArea.classList.contains('split-view')
                    || workArea.classList.contains('split-view-ai')
                    || workArea.classList.contains('trio-view')
                    || workArea.classList.contains('pdf-tutor-quiz-duo')
                    || workArea.classList.contains('pdf-tutor-quiz-trio'))
            );
            card.style.margin = hasMultiPaneLayout ? '' : '0 auto 2rem auto';
            card.style.zIndex = '';
        }

        if (!restoreLayout && persist) persistActiveResizeGeometry();
        resizeStartedFloating = false;
        scheduleQuizCardContentScaleSync();
        scheduleQuickActionsDockPosition();
        syncFloatingQuizLayering();
        return true;
    }

    function startResize(e, edges) {
        if (!canDirectResize()) return;
        if (e.button !== 0) return;
        e.preventDefault();
        e.stopImmediatePropagation?.();
        e.stopPropagation();
        isResizing = true;
        resizeEdges = edges;
        startRect = card.getBoundingClientRect();
        isQuizCardManualResizeActive = true;
        card.classList.add('is-resizing');
        setQuizCardManualGeometryState(true);
        resizeStartedFloating = card.classList.contains('is-floating');

        if (resizeStartedFloating) {
            card.style.maxHeight = 'none';
            card.style.margin = '0';
            card.style.zIndex = FLOATING_QUIZ_Z_INDEX;
            card.style.overflow = '';
        }

        const cursor = getResizeCursor(edges);
        card.style.cursor = cursor;
        document.body.style.cursor = cursor;
        document.querySelectorAll('iframe').forEach((frame) => { frame.style.pointerEvents = 'none'; });
    }

    if (handle) {
        handle.addEventListener('mousedown', (e) => {
            startResize(e, { top: false, right: true, bottom: true, left: false });
        });
    }

    card.addEventListener('mousedown', (e) => {
        if (!canDirectResize()) return;
        if (e.button !== 0) return;
        if (e.target?.closest?.(resizeIgnoreSelector)) return;
        const edges = getResizeEdgesFromEvent(e);
        if (!hasResizeEdge(edges)) return;
        startResize(e, edges);
    }, true);

    card.addEventListener('mousemove', (e) => {
        if (isResizing) return;
        if (!canDirectResize() || e.target?.closest?.(resizeIgnoreSelector)) {
            card.style.cursor = '';
            return;
        }
        card.style.cursor = getResizeCursor(getResizeEdgesFromEvent(e));
    });

    card.addEventListener('mouseleave', () => {
        if (!isResizing) card.style.cursor = '';
    });

    const quizCardResizeMoveThrottled = createRafDragThrottle((e) => {
        if (!isResizing || !startRect || !hasResizeEdge(resizeEdges)) return;
        if (!canDirectResize()) {
            clearResizeInteraction({ restoreLayout: true, persist: false });
            return;
        }
        const isHorizontalResize = resizeEdges.left || resizeEdges.right;
        const isVerticalResize = resizeEdges.top || resizeEdges.bottom;
        let maxW;
        let maxH;
        if (resizeStartedFloating) {
            maxW = resizeEdges.left
                ? Math.max(280, startRect.right - 8)
                : Math.max(280, window.innerWidth - startRect.left - 8);
            maxH = resizeEdges.top
                ? Math.max(220, startRect.bottom - 8)
                : Math.max(220, window.innerHeight - startRect.top - 8);
        } else {
            const bounds = getQuizCardSizeBounds('single');
            maxW = bounds.maxW;
            maxH = bounds.maxH;
        }
        const minW = Math.min(QUIZ_CARD_MIN_WIDTH, maxW);
        const minH = Math.min(QUIZ_CARD_MIN_HEIGHT, maxH);

        let nextW = startRect.width;
        let nextH = startRect.height;
        if (isHorizontalResize) {
            const rawW = resizeEdges.left
                ? startRect.right - e.clientX
                : e.clientX - startRect.left;
            nextW = Math.min(Math.max(rawW, minW), maxW);
            card.style.width = Math.round(nextW) + 'px';
        }

        if (isVerticalResize) {
            const rawH = resizeEdges.top
                ? startRect.bottom - e.clientY
                : e.clientY - startRect.top;
            nextH = Math.min(Math.max(rawH, minH), maxH);
            card.style.height = Math.round(nextH) + 'px';
        }

        if (resizeStartedFloating) {
            if (resizeEdges.left && isHorizontalResize) {
                card.style.left = Math.round(Math.max(8, startRect.right - nextW)) + 'px';
            }
            if (resizeEdges.top && isVerticalResize) {
                card.style.top = Math.round(Math.max(8, startRect.bottom - nextH)) + 'px';
            }
        }

        persistActiveResizeGeometry();
        applyQuizCardContentScale();
        scheduleQuickActionsDockPosition();
        if (els.popup.classList.contains('active') && currentPopupBtn) updatePopupPosition();
    });

    document.addEventListener('mousemove', (e) => {
        if (!isResizing) return;
        if (!canDirectResize()) {
            clearResizeInteraction({ restoreLayout: true, persist: false });
            return;
        }
        quizCardResizeMoveThrottled(e);
    });

    document.addEventListener('mouseup', () => {
        if (!isResizing) return;
        if (!canDirectResize()) {
            clearResizeInteraction({ restoreLayout: true, persist: false });
            return;
        }
        quizCardResizeMoveThrottled.flush();
        clearResizeInteraction({ persist: true });
    });

    const resizeLayoutObserver = new MutationObserver(() => {
        if (canDirectResize()) return;
        card.style.cursor = '';
        if (isResizing) clearResizeInteraction({ restoreLayout: true, persist: false });
    });
    resizeLayoutObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    const workArea = els?.workArea || $('work-area');
    if (workArea) resizeLayoutObserver.observe(workArea, { attributes: true, attributeFilter: ['class'] });

    window.addEventListener('beforeunload', () => {
        if (!isResizing || !canDirectResize()) return;
        persistActiveResizeGeometry();
    });
}

function setupDrag() {
    const card = els?.quizCard || $('quiz-card');
    if (!card || card.dataset.dragBound === '1') return;
    card.dataset.dragBound = '1';

    let isDragging = false;
    let startX;
    let startY;
    let initialLeft;
    let initialTop;

    function makeFloating() {
        const currentScale = parseFloat(getComputedStyle(els.quizCard).getPropertyValue('--quiz-content-scale')) || 1;
        const rect = els.quizCard.getBoundingClientRect();
        els.quizCard.classList.add('is-floating');
        els.quizCard.dataset.floatingContentScale = currentScale.toFixed(4);
        els.quizCard.style.position = 'fixed';
        els.quizCard.style.left = rect.left + 'px';
        els.quizCard.style.top = rect.top + 'px';
        els.quizCard.style.width = rect.width + 'px';
        els.quizCard.style.height = '';
        els.quizCard.style.maxHeight = 'none';
        els.quizCard.style.margin = '0';
        els.quizCard.style.zIndex = FLOATING_QUIZ_Z_INDEX;
        els.quizCard.style.overflow = '';
        syncQuizCardCustomGeometryState();
        applyQuizCardContentScale();
        scheduleQuickActionsDockPosition();
        return els.quizCard.getBoundingClientRect();
    }

    card.addEventListener('mousedown', (e) => {
        if (!QUIZ_CARD_SHIFT_DRAG_FLOATING_ENABLED) return;
        if (isQuizCardExpanded || document.body.classList.contains('pdf-tutor-quiz-mode')) return;
        if (document.body.classList.contains('ask-ai-docked-open') && getQuizCardLayoutMode() === 'single') return;
        if (!e.shiftKey || e.target.closest('button, select, input, .choice, a, #resize-handle')) return;
        e.preventDefault();
        isDragging = true;
        let rect;
        if (!els.quizCard.classList.contains('is-floating')) {
            rect = makeFloating();
        } else {
            rect = els.quizCard.getBoundingClientRect();
            const maxH = window.innerHeight - rect.top - 16;
            if (rect.height > maxH && maxH > 200) {
                els.quizCard.style.height = maxH + 'px';
                syncQuizCardCustomGeometryState();
            }
        }
        startX = e.clientX;
        startY = e.clientY;
        initialLeft = rect.left;
        initialTop = rect.top;
        els.quizCard.style.cursor = 'grabbing';
    });

    const quizCardDragMoveThrottled = createRafDragThrottle((e) => {
        if (!isDragging) return;
        const w = els.quizCard.offsetWidth;
        const h = els.quizCard.offsetHeight;
        let newLeft = initialLeft + e.clientX - startX;
        let newTop = initialTop + e.clientY - startY;
        newLeft = Math.max(0, Math.min(newLeft, window.innerWidth - w));
        newTop = Math.max(8, newTop);
        els.quizCard.style.left = newLeft + 'px';
        els.quizCard.style.top = newTop + 'px';
        scheduleQuickActionsDockPosition();
        if (els.popup.classList.contains('active') && currentPopupBtn) updatePopupPosition();
    });

    document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        quizCardDragMoveThrottled(e);
    });

    document.addEventListener('mouseup', () => {
        if (isDragging) {
            quizCardDragMoveThrottled.flush();
            isDragging = false;
            els.quizCard.style.cursor = 'auto';
            syncFloatingQuizLayering();
            scheduleQuickActionsDockPosition();
        }
    });
}

function syncActivePopupPosition() {
    if (els.popup?.classList.contains('active') && currentPopupBtn) updatePopupPosition();
}

function scheduleActivePopupPositionSync() {
    if (activePopupPositionSyncRaf) cancelAnimationFrame(activePopupPositionSyncRaf);
    activePopupPositionSyncRaf = requestAnimationFrame(() => {
        activePopupPositionSyncRaf = 0;
        syncActivePopupPosition();
        requestAnimationFrame(syncActivePopupPosition);
        setTimeout(syncActivePopupPosition, 90);
        setTimeout(syncActivePopupPosition, 220);
        setTimeout(syncActivePopupPosition, 420);
    });
}

function resetQuizCardPosition({ forceLayoutDefault = false, layoutMode = getQuizCardLayoutMode(), preserveExpandedLock = false } = {}) {
    if (isQuizCardExpanded) {
        if (preserveExpandedLock) {
            scheduleQuizCardContentScaleSync({ forceReset: true });
            scheduleActivePopupPositionSync();
            syncFloatingQuizLayering();
            return;
        }
        toggleQuizCardExpanded(false);
    }
    els.quizCard.classList.remove('is-floating');
    delete els.quizCard.dataset.floatingContentScale;
    els.quizCard.style.position = '';
    els.quizCard.style.left = '';
    els.quizCard.style.top = '';
    els.quizCard.style.width = '';
    els.quizCard.style.height = '';
    els.quizCard.style.margin = '';
    els.quizCard.style.zIndex = '';
    els.quizCard.style.display = 'block';
    els.quizCard.style.maxWidth = '';
    els.quizCard.style.maxHeight = '';
    els.quizCard.style.transform = '';
    els.quizCard.style.overflow = '';
    syncQuizCardCustomGeometryState();
    if (forceLayoutDefault) {
        if (!resetQuizCardToLayoutDefault(layoutMode)) {
            applyQuizCardContentScale({ forceReset: true });
        }
        scheduleActivePopupPositionSync();
        return;
    }
    if (!restoreQuizCardGeometryForCurrentLayout(layoutMode)) {
        applyQuizCardContentScale({ forceReset: true });
        scheduleActivePopupPositionSync();
        return;
    }
    scheduleQuizCardContentScaleSync();
    scheduleActivePopupPositionSync();
}

function scheduleQuizCardPositionReset(options = {}) {
    if (quizCardPositionResetFrame) cancelAnimationFrame(quizCardPositionResetFrame);
    quizCardPositionResetFrame = requestAnimationFrame(() => {
        quizCardPositionResetFrame = 0;
        resetQuizCardPosition(options);
    });
}

function scheduleFloatingQuizCardReanchorForManagedLayout(options = {}) {
    const card = els?.quizCard || $('quiz-card');
    if (!card?.classList?.contains('is-floating')) return false;
    scheduleQuizCardPositionReset(options);
    return true;
}

function bindQuickActionsDockEvents() {
    if (!els.quickActionsDock || !els.quickActionsTrigger || !els.quickActionsMenu) return;
    if (els.quickActionsDock.dataset.quickDockBound === '1') return;
    els.quickActionsDock.dataset.quickDockBound = '1';

    syncQuickActionsMenuState();
    els.quickActionsMenu.setAttribute('hidden', '');

    els.quickActionsDock.addEventListener('focusin', (event) => {
        // Opening already focuses an item. Reopening here would regroup that focused
        // node, emit focusout, and immediately close the menu.
        if (quickActionsDockOpen || event.target === els.quickActionsTrigger) return;
        setQuickActionsDockOpen(true);
    });

    els.quickActionsDock.addEventListener('focusout', (event) => {
        const nextFocus = event.relatedTarget;
        if (nextFocus && els.quickActionsDock.contains(nextFocus)) return;
        closeQuickActionsDock();
    });

    let triggerPointerOpenState = null;
    els.quickActionsTrigger.addEventListener('pointerdown', () => {
        // Preserve the state before pointer focus can close the portaled menu.
        triggerPointerOpenState = quickActionsDockOpen;
    });
    els.quickActionsTrigger.addEventListener('pointercancel', () => {
        triggerPointerOpenState = null;
    });
    els.quickActionsTrigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const wasOpen = event.detail > 0 && triggerPointerOpenState !== null
            ? triggerPointerOpenState : quickActionsDockOpen;
        triggerPointerOpenState = null;
        setQuickActionsDockOpen(!wasOpen, { focusFirst: !wasOpen });
    });

    let quickActionPointerHandledAt = 0;
    const runQuickAction = (event) => {
        const actionBtn = event.target.closest('.quiz-quick-action-btn[data-quick-action]');
        if (!actionBtn || actionBtn.disabled || actionBtn.classList.contains('is-disabled')) return;
        event.preventDefault();
        event.stopPropagation();

        if (event.type === 'click' && Date.now() - quickActionPointerHandledAt < 700) return;
        if (event.type === 'pointerdown') quickActionPointerHandledAt = Date.now();

        const action = actionBtn.dataset.quickAction;
        if (action === 'exam') {
            window.MemoraExamMode?.configure(els.quickActionsMenu, els.quickActionsTrigger);
            return;
        }
        if (action === 'mix') els.mixAnswersBtn?.click();
        if (action === 'hard') els.hardModeBtn?.click();
        if (action === 'shuffle') els.shuffleBtn?.click();
        if (action === 'notes' && typeof openMyNotesModal === 'function') openMyNotesModal();
        if (action === 'saved' && typeof openSavedModal === 'function') void openSavedModal();
        if (action === 'regenerate' && typeof regenerateCurrentQuizQuestion === 'function') void regenerateCurrentQuizQuestion();
        if (action === 'refresh-question') $('refresh-question-btn')?.click();
        if (action === 'refresh-quiz') $('refresh-quiz-btn')?.click();

        syncQuickActionsMenuState();
        closeQuickActionsDock();
    };
    // Touch focus changes can close the inline phone menu before its click event.
    // Run the action on pointerdown and retain click support for keyboard users.
    els.quickActionsMenu.addEventListener('pointerdown', runQuickAction);
    els.quickActionsMenu.addEventListener('click', runQuickAction);

    els.quickActionsMenu.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        closeQuickActionsDock();
        els.quickActionsTrigger.focus();
    });
}

let windowPopupScrollSyncBound = false;
let windowPopupScrollSyncRaf = 0;
function handleWindowPopupScrollSync() {
    // Any scroll anywhere (outer page container, panes, nested scrollers) can
    // move the anchor out of view. Scroll events don't bubble, so a listener on
    // #quiz-card / #quiz-content-wrapper misses the inline single-card layout
    // where those elements are overflow:visible and an ancestor scrolls instead.
    // A capturing window listener catches every scroll; rAF-throttle keeps it cheap.
    if (!els.popup?.classList.contains('active') || !currentPopupBtn) return;
    if (windowPopupScrollSyncRaf) return;
    windowPopupScrollSyncRaf = requestAnimationFrame(() => {
        windowPopupScrollSyncRaf = 0;
        syncActivePopupPosition();
    });
}

function bindQuizPopupPositionSync() {
    const card = els?.quizCard || $('quiz-card');
    const content = els?.quizContent || $('quiz-content-wrapper');
    if (card && card.dataset.popupSyncBound !== '1') {
        card.dataset.popupSyncBound = '1';
        card.addEventListener('scroll', syncActivePopupPosition);
    }
    if (content && content.dataset.popupSyncBound !== '1') {
        content.dataset.popupSyncBound = '1';
        content.addEventListener('scroll', syncActivePopupPosition);
    }
    if (!windowPopupScrollSyncBound) {
        windowPopupScrollSyncBound = true;
        // Capture phase so we also see scrolls on nested containers that don't bubble.
        window.addEventListener('scroll', handleWindowPopupScrollSync, true);
        // Safari can move or resize the visual viewport without emitting a layout
        // viewport scroll. Keep fixed, body-portaled callouts anchored during that shift.
        window.visualViewport?.addEventListener('scroll', handleWindowPopupScrollSync, { passive: true });
        window.visualViewport?.addEventListener('resize', handleWindowPopupScrollSync, { passive: true });
    }
}

function bindQuizUiSurface() {
    const card = els?.quizCard || $('quiz-card');
    const content = els?.quizContent || $('quiz-content-wrapper');
    const shell = els?.quizScaleShell || $('quiz-scale-shell');
    const navRow = $('nav-row');
    const question = $('question');
    const choices = $('choices');
    const explanation = $('explanation');
    const expandLock = $('quiz-expand-lock-btn-inline');
    if (card) card.setAttribute('data-testid', 'quiz-card');
    if (content) content.setAttribute('data-testid', 'quiz-content');
    if (navRow) navRow.setAttribute('data-testid', 'quiz-nav');
    if (question) question.setAttribute('data-testid', 'quiz-question');
    if (expandLock) expandLock.setAttribute('data-testid', 'quiz-expand-lock');

    ensureQuizQuickActionsMarkup();
    bindQuickActionsDockTransitionTracking();
    bindQuickActionsDockEvents();
    bindQuizPopupPositionSync();

    if (card && card.dataset.pinchZoomBound !== '1') {
        card.dataset.pinchZoomBound = '1';
        // Keep one-finger scrolling native, but reserve two-finger pinches for
        // quiz content scaling instead of Safari's page-level viewport zoom.
        card.style.touchAction = 'pan-y';

        let previousPinchDistance = 0;
        let accumulatedPinchChange = 0;
        const pinchStepThreshold = 0.08;
        const getPinchDistance = (touches) => {
            if (!touches || touches.length !== 2) return 0;
            return Math.hypot(
                touches[1].clientX - touches[0].clientX,
                touches[1].clientY - touches[0].clientY
            );
        };
        const resetPinchZoom = () => {
            previousPinchDistance = 0;
            accumulatedPinchChange = 0;
        };

        card.addEventListener('touchstart', (event) => {
            if (event.touches.length !== 2) {
                resetPinchZoom();
                return;
            }
            previousPinchDistance = getPinchDistance(event.touches);
            accumulatedPinchChange = 0;
            if (event.cancelable) event.preventDefault();
        }, { passive: false });

        card.addEventListener('touchmove', (event) => {
            if (event.touches.length !== 2) {
                resetPinchZoom();
                return;
            }

            const nextDistance = getPinchDistance(event.touches);
            if (event.cancelable) event.preventDefault();
            if (previousPinchDistance <= 0 || nextDistance <= 0) {
                previousPinchDistance = nextDistance;
                return;
            }

            accumulatedPinchChange += Math.log(nextDistance / previousPinchDistance);
            previousPinchDistance = nextDistance;

            let appliedSteps = 0;
            while (Math.abs(accumulatedPinchChange) >= pinchStepThreshold && appliedSteps < 4) {
                const direction = accumulatedPinchChange > 0 ? 1 : -1;
                if (!nudgeQuizCardContentScale(direction)) break;
                accumulatedPinchChange -= direction * pinchStepThreshold;
                appliedSteps += 1;
            }
        }, { passive: false });

        card.addEventListener('touchend', resetPinchZoom, { passive: true });
        card.addEventListener('touchcancel', resetPinchZoom, { passive: true });
        card.addEventListener('gesturestart', (event) => {
            if (event.cancelable) event.preventDefault();
        }, { passive: false });
        card.addEventListener('gesturechange', (event) => {
            if (event.cancelable) event.preventDefault();
        }, { passive: false });
    }

    if (!quizCardHeightObserver && typeof ResizeObserver === 'function') {
        quizCardHeightObserver = new ResizeObserver(() => {
            if (deferQuizCardWorkForPaneTransition()) return;
            scheduleQuizCardHeightNormalization();
            syncQuizCompanionVerticalGeometry();
            if (document.documentElement.classList.contains('phone-device')) {
                scheduleQuizCardContentScaleSync();
            }
        });
        [card, content, shell, navRow, question, choices, explanation].forEach((el) => {
            if (el) quizCardHeightObserver.observe(el);
        });
    }
}


window.addEventListener('resize', scheduleQuickActionsDockPosition);
window.addEventListener('scroll', scheduleQuickActionsDockPosition, { passive: true });
document.addEventListener('scroll', scheduleQuickActionsDockPosition, { passive: true, capture: true });
if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleQuickActionsDockPosition, { passive: true });
    window.visualViewport.addEventListener('scroll', scheduleQuickActionsDockPosition, { passive: true });
}

window.addEventListener('resize', () => {
    const card = els?.quizCard || $('quiz-card');
    if (!isQuizCardExpanded && !(card?.classList?.contains('is-floating'))) {
        restoreQuizCardGeometryForCurrentLayout();
    }
    scheduleQuizCardContentScaleSync();
    syncQuizCompanionVerticalGeometry();
    if (card
        && document.body?.classList?.contains('ask-ai-docked-open')
        && card?.dataset?.quizManualGeometry !== '1') {
        card.dataset.quizDockedAskRestoreHeight = card.style.height || '';
        requestAnimationFrame(() => scheduleQuizCardHeightNormalization());
    }
});

document.addEventListener('transitionend', (event) => {
    if (!event.target) return;
    const id = event.target.id;
    if (id === 'work-area' || id === 'quiz-pane' || id === 'ai-pane' || id === 'pdf-pane' || id === 'quiz-card' || event.target.classList.contains('modal-content')) {
        if (isQuizPaneLayoutTransitioning()) {
            window.whenPaneLayoutSettled?.(runQuizCardLayoutSettlePass);
            return;
        }
        scheduleQuizCardContentScaleSync();
    }
}, { passive: true });


(function initializeQuizUiSurface() {
    bindQuizUiSurface();
    const workArea = els?.workArea || $('work-area');
    if (!quizWorkspaceWidthObserver && workArea && typeof ResizeObserver === 'function') {
        quizWorkspaceWidthObserver = new ResizeObserver(() => {
            window.clearTimeout(quizWorkspaceWidthSettleTimer);
            quizWorkspaceWidthSettleTimer = window.setTimeout(() => {
                const pane = $('quiz-pane');
                const card = els?.quizCard || $('quiz-card');
                if (!pane || !card || isQuizCardExpanded || isQuizCardManualResizeActive
                    || document.body.classList.contains('ask-ai-docked-open')
                    || document.body.classList.contains('notes-docked-open')) return;
                const paneRect = pane.getBoundingClientRect();
                const cardRect = card.getBoundingClientRect();
                if (card.classList.contains('is-floating')) {
                    const maxWidth = Math.max(320, paneRect.right - paneRect.left - 24);
                    const width = Math.min(cardRect.width, maxWidth);
                    const left = Math.max(paneRect.left + 12, Math.min(cardRect.left, paneRect.right - width - 12));
                    if (cardRect.width > maxWidth + 1) card.style.width = `${Math.round(width)}px`;
                    if (Math.abs(cardRect.left - left) > 1) card.style.left = `${Math.round(left)}px`;
                } else {
                    // Rail expansion changes workspace width without firing window.resize.
                    // Reapply the saved manual size through the current pane bounds.
                    restoreQuizCardGeometryForCurrentLayout();
                }
                scheduleQuizCardContentScaleSync();
                scheduleQuickActionsDockPosition();
                syncQuizCompanionVerticalGeometry();
            }, 90);
        });
        quizWorkspaceWidthObserver.observe(workArea);
    }
    if (typeof MutationObserver === 'function' && document.body) {
        const dockedAskClassObserver = new MutationObserver(() => {
            const card = els?.quizCard || $('quiz-card');
            if (!card
                || document.body.classList.contains('ask-ai-docked-open')
                || !('quizDockedAskRestoreHeight' in card.dataset)) return;

            const restoreHeight = card.dataset.quizDockedAskRestoreHeight;
            if (restoreHeight) card.style.height = restoreHeight;
            else card.style.removeProperty('height');
            delete card.dataset.quizDockedAskRestoreHeight;
            syncQuizCardCustomGeometryState();
            scheduleQuizCardContentScaleSync();
            scheduleQuickActionsDockPosition();
        });
        dockedAskClassObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
    restoreQuizCardGeometryForCurrentLayout();
    scheduleQuizCardContentScaleSync();
    scheduleQuickActionsDockPosition();
})();
